import React from 'react';
import { useEffect, useState, useRef, createRef, useImperativeHandle } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryGridAr from "../components/EntryGridAr";
import EntrySetting from "../components/EntrySetting";
import EntryRemarks from "../components/EntryRemarks";
import EntryImages from "../components/EntryImages";
import EntryBase from "../components/EntryBase";
import EntryLayout from '../components/EntryLayout';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Chip from '@material-ui/core/Chip';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import { styled } from '@material-ui/core/styles';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import {
    isEmpty, Getstorage, Savestorage, DeepCopy, getWindowDimensions,
    getformid, getcontroller, getsubkey, initializedata, isEnabled, DicVal, NumConv
} from '../modules/appLibrary';
import { setimagelist } from '../modules/imagedlgstore';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption, entryrerender } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup } from '../modules/toolpanelstore';

// パネル移動用のチップを並べるためのリスト要素です。
// 画面設計書の各パネルをツールバー上で選択・並べ替えできるようにする表示部品です。
const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

// 明細グリッド操作を担当する AGFunction を ref 経由で使えるようにした共通部品です。
const RawPurchaseEntryBaseAGFunc = React.forwardRef(AGFunction);
// 警告表示、通信、待機表示、レイアウト補助などの共通処理を ref 経由で使うための ComFunction です。
const RawPurchaseEntryBaseComFunc = React.forwardRef(ComFunction);
// 原材料仕入入力のヘッダーで共通的に参照する主要カラムIDを集約します。
// 伝票番号、参照元伝票区分、参照元伝票番号、区分をコード中で同じ名前で扱うための対応表です。
export const RAW_PURCHASE_ENTRY_FIELD_IDS = {
    slipNo: "ZSR_DENNO",
    sourceCategoryCode: "ZSR_SANMOTODENKBN",
    referenceSlipNo: "ZSR_SANSYODENNO",
    materialCategoryCode: "ZSR_ZAIRYOKBN",
    brandCode: "ZSR_BRDCD",
    supplierCode: "ZSR_SIIRESAKICD"
};

// 明細行間で補完するカット代関連の文脈項目です。
// 画面設計書の「カット（品番固定）代のみ追加OK」などの明細追加条件で使う値を保持します。
const RAW_PURCHASE_ENTRY_DETAIL_CONTEXT_FIELD_IDS = [
    "CutCostHinban",
    "CutCostSiireSakiCd",
    "CutCostBrdCd"
];

// 参照元組み合わせ表の判定キーになるヘッダー項目のカラムIDです。
// 区分、仕入種別、伝票種別、伝票区分のうち、区分以外の3項目をまとめています。
const RAW_PURCHASE_ENTRY_COMBINATION_FIELD_IDS = {
    purchaseKindCode: "ZSR_SIIREKIND",
    slipTypeCode: "ZSR_DENSYUBETU",
    slipCategoryCode: "ZSR_DENKBN"
};

// 参照元伝票区分から実際に開く Entry 画面の実装状況を定義します。
// AGENTS.md の参照元伝票区分表に対応し、発注(4)のような対象外画面を未実装として扱います。
const RAW_PURCHASE_ENTRY_ROUTE_DEFINITIONS = {
    "": {
        sourceCategoryCode: "",
        implemented: true
    },
    "3": {
        sourceCategoryCode: "3",
        implemented: true
    },
    "4": {
        sourceCategoryCode: "4",
        implemented: false
    },
    "5": {
        sourceCategoryCode: "5",
        implemented: true
    },
    "6": {
        sourceCategoryCode: "6",
        implemented: true
    },
    "7": {
        sourceCategoryCode: "7",
        implemented: true
    },
    "9": {
        sourceCategoryCode: "9",
        implemented: true
    }
};

// ZSR_SANMOTODENKBN に表示する参照元伝票区分の候補です。
// 参照元組み合わせ表で許可された候補だけに絞り込む元データとして使います。
const RAW_PURCHASE_ENTRY_SOURCE_CATEGORY_OPTIONS = [
    { code: "", name: "" },
    { code: "3", name: "出荷実績" },
    { code: "4", name: "発注" },
    { code: "5", name: "売上" },
    { code: "6", name: "社内売買" },
    { code: "7", name: "原材料仕入" },
    { code: "9", name: "サンプル納品明細" }
];

// 参照元組み合わせ表に該当する参照元が存在しない場合に表示するローカル候補です。
// 値は空のままにして、参照先の入力欄には何も入らないようにします。
const RAW_PURCHASE_ENTRY_NO_REFERENCE_OPTION = {
code: "",
    name: "該当する参照元はありません"
};

// 原材料仕入入力参照元組み合わせ表をコード化したルールです。
// 区分、仕入種別、伝票種別、伝票区分の組み合わせごとに、選択可能な参照元と必須/任意を判定します。
const RAW_PURCHASE_ENTRY_REFERENCE_RULES = [
    { materialCategoryCode: "1", purchaseKindCode: "0", slipTypeCode: "01", slipCategoryCode: "1", sourceCategoryCode: "3", required: true },
    { materialCategoryCode: "1", purchaseKindCode: "0", slipTypeCode: "01", slipCategoryCode: "2", sourceCategoryCode: "6", required: true },
    { materialCategoryCode: "1", purchaseKindCode: "0", slipTypeCode: "01", slipCategoryCode: "3", sourceCategoryCode: "5", required: true },
    { materialCategoryCode: "1", purchaseKindCode: "0", slipTypeCode: "02", slipCategoryCode: "1", sourceCategoryCode: "7", required: true },
    { materialCategoryCode: "1", purchaseKindCode: "0", slipTypeCode: "02", slipCategoryCode: "2", sourceCategoryCode: "6", required: true },
    { materialCategoryCode: "1", purchaseKindCode: "0", slipTypeCode: "02", slipCategoryCode: "3", sourceCategoryCode: "5", required: true },
    { materialCategoryCode: "1", purchaseKindCode: "0", slipTypeCode: "03", slipCategoryCode: "1", sourceCategoryCode: "7", required: false },
    { materialCategoryCode: "1", purchaseKindCode: "0", slipTypeCode: "03", slipCategoryCode: "2", sourceCategoryCode: "6", required: true },
    { materialCategoryCode: "1", purchaseKindCode: "0", slipTypeCode: "03", slipCategoryCode: "3", sourceCategoryCode: "5", required: true },
    { materialCategoryCode: "1", purchaseKindCode: "0", slipTypeCode: "04", slipCategoryCode: "1", sourceCategoryCode: "7", required: false },
    { materialCategoryCode: "1", purchaseKindCode: "0", slipTypeCode: "04", slipCategoryCode: "2", sourceCategoryCode: "6", required: true },
    { materialCategoryCode: "1", purchaseKindCode: "0", slipTypeCode: "04", slipCategoryCode: "3", sourceCategoryCode: "5", required: true },
    { materialCategoryCode: "1", purchaseKindCode: "1", slipTypeCode: "01", slipCategoryCode: "1", sourceCategoryCode: "9", required: false },
    { materialCategoryCode: "1", purchaseKindCode: "1", slipTypeCode: "02", slipCategoryCode: "1", sourceCategoryCode: "7", required: true },
    { materialCategoryCode: "1", purchaseKindCode: "1", slipTypeCode: "03", slipCategoryCode: "1", sourceCategoryCode: "7", required: false },
    { materialCategoryCode: "1", purchaseKindCode: "1", slipTypeCode: "04", slipCategoryCode: "1", sourceCategoryCode: "7", required: false },
    { materialCategoryCode: "2", purchaseKindCode: "0", slipTypeCode: "01", slipCategoryCode: "1", sourceCategoryCode: "3", required: true },
    { materialCategoryCode: "2", purchaseKindCode: "0", slipTypeCode: "01", slipCategoryCode: "2", sourceCategoryCode: "6", required: true },
    { materialCategoryCode: "2", purchaseKindCode: "0", slipTypeCode: "01", slipCategoryCode: "3", sourceCategoryCode: "5", required: true },
    { materialCategoryCode: "2", purchaseKindCode: "0", slipTypeCode: "02", slipCategoryCode: "1", sourceCategoryCode: "7", required: true },
    { materialCategoryCode: "2", purchaseKindCode: "0", slipTypeCode: "02", slipCategoryCode: "2", sourceCategoryCode: "6", required: true },
    { materialCategoryCode: "2", purchaseKindCode: "0", slipTypeCode: "02", slipCategoryCode: "3", sourceCategoryCode: "5", required: true },
    { materialCategoryCode: "2", purchaseKindCode: "0", slipTypeCode: "03", slipCategoryCode: "1", sourceCategoryCode: "7", required: false },
    { materialCategoryCode: "2", purchaseKindCode: "0", slipTypeCode: "03", slipCategoryCode: "2", sourceCategoryCode: "6", required: true },
    { materialCategoryCode: "2", purchaseKindCode: "0", slipTypeCode: "03", slipCategoryCode: "3", sourceCategoryCode: "5", required: true },
    { materialCategoryCode: "2", purchaseKindCode: "0", slipTypeCode: "04", slipCategoryCode: "1", sourceCategoryCode: "7", required: false },
    { materialCategoryCode: "2", purchaseKindCode: "0", slipTypeCode: "04", slipCategoryCode: "2", sourceCategoryCode: "6", required: true },
    { materialCategoryCode: "2", purchaseKindCode: "0", slipTypeCode: "04", slipCategoryCode: "3", sourceCategoryCode: "5", required: true },
    { materialCategoryCode: "2", purchaseKindCode: "1", slipTypeCode: "01", slipCategoryCode: "1", sourceCategoryCode: "9", required: false },
    { materialCategoryCode: "2", purchaseKindCode: "1", slipTypeCode: "02", slipCategoryCode: "1", sourceCategoryCode: "7", required: true },
    { materialCategoryCode: "2", purchaseKindCode: "1", slipTypeCode: "03", slipCategoryCode: "1", sourceCategoryCode: "7", required: false },
    { materialCategoryCode: "2", purchaseKindCode: "1", slipTypeCode: "04", slipCategoryCode: "1", sourceCategoryCode: "7", required: false },
    { materialCategoryCode: "3", purchaseKindCode: "0", slipTypeCode: "01", slipCategoryCode: "1", sourceCategoryCode: "3", required: true },
    { materialCategoryCode: "3", purchaseKindCode: "0", slipTypeCode: "01", slipCategoryCode: "2", sourceCategoryCode: "6", required: true },
    { materialCategoryCode: "3", purchaseKindCode: "0", slipTypeCode: "02", slipCategoryCode: "1", sourceCategoryCode: "7", required: true },
    { materialCategoryCode: "3", purchaseKindCode: "0", slipTypeCode: "02", slipCategoryCode: "2", sourceCategoryCode: "6", required: true },
    { materialCategoryCode: "3", purchaseKindCode: "0", slipTypeCode: "02", slipCategoryCode: "3", sourceCategoryCode: "5", required: true },
    { materialCategoryCode: "3", purchaseKindCode: "0", slipTypeCode: "03", slipCategoryCode: "1", sourceCategoryCode: "7", required: false },
    { materialCategoryCode: "3", purchaseKindCode: "0", slipTypeCode: "03", slipCategoryCode: "2", sourceCategoryCode: "6", required: true },
    { materialCategoryCode: "3", purchaseKindCode: "0", slipTypeCode: "03", slipCategoryCode: "3", sourceCategoryCode: "5", required: true },
    { materialCategoryCode: "3", purchaseKindCode: "0", slipTypeCode: "04", slipCategoryCode: "1", sourceCategoryCode: "7", required: false },
    { materialCategoryCode: "3", purchaseKindCode: "0", slipTypeCode: "04", slipCategoryCode: "2", sourceCategoryCode: "6", required: true },
    { materialCategoryCode: "3", purchaseKindCode: "0", slipTypeCode: "04", slipCategoryCode: "3", sourceCategoryCode: "5", required: true },
    { materialCategoryCode: "3", purchaseKindCode: "1", slipTypeCode: "02", slipCategoryCode: "1", sourceCategoryCode: "7", required: true },
    { materialCategoryCode: "3", purchaseKindCode: "1", slipTypeCode: "03", slipCategoryCode: "1", sourceCategoryCode: "7", required: false },
    { materialCategoryCode: "3", purchaseKindCode: "1", slipTypeCode: "04", slipCategoryCode: "1", sourceCategoryCode: "7", required: false }
];

// 素材明細の合計パネルに出す数量・外貨金額・円貨金額の計算式定義です。
// 素材はメートル数量を基準にするため ZSRM_SIIREMETERSU を数量合計に使います。
// 金額計は明細行で確定した結果列を合算し、行表示と合計表示の根拠をそろえます。
const rawPurchaseEntryTotalCalculationsZai = [
    {
        targetColumnId: "ZSRM_QTY_T",
        rowFormula: ["ZSRM_SIIREMETERSU"]
    },
    {
        targetColumnId: "ZSRM_AMTF_T",
        rowFormula: ["ZSRM_SIIREKINGAKUF"]
    },
    {
        targetColumnId: "ZSRM_AMTZ_T",
        rowFormula: ["ZSRM_KINGAKUZ"]
    }
];

// 附属・副資材明細の合計パネルに出す数量・外貨金額・円貨金額の計算式定義です。
// 素材以外は仕入数 ZSRM_SIIRESU を数量合計に使います。
// 外貨金額計も明細の結果列を足し、数量変更やレート変更時の見え方を統一します。
const rawPurchaseEntryTotalCalculationsOther = [
    {
        targetColumnId: "ZSRM_QTY_T",
        rowFormula: ["ZSRM_SIIRESU"]
    },
    {
        targetColumnId: "ZSRM_AMTF_T",
        rowFormula: ["ZSRM_SIIREKINGAKUF"]
    },
    {
        targetColumnId: "ZSRM_AMTZ_T",
        rowFormula: ["ZSRM_KINGAKUZ"]
    }
];

// 参照元伝票区分を比較しやすい文字列へ正規化します。
// DB・画面・遷移 state から来る ZSR_SANMOTODENKBN の空白差を吸収します。
export function normalizeRawPurchaseEntrySourceCategoryCode(value) {
    const normalized = String(value ?? "").trim();
    return normalized === "0" ? "" : normalized;
}

// 区分(ZSR_ZAIRYOKBN)を比較用の文字列へ正規化します。
// 参照元組み合わせ表の「素材/附属/副資材」に対応するコード判定で使います。
function normalizeRawPurchaseEntryMaterialCategoryCode(value) {
    return String(value ?? "").trim();
}

// 仕入種別(ZSR_SIIREKIND)を参照元組み合わせ表の判定値に正規化します。
function normalizeRawPurchaseEntryPurchaseKindCode(value) {
    const normalized = String(value ?? "").trim();
    if (normalized === "0" || normalized === "1") return normalized;
    return normalized;
}

// 伝票種別(ZSR_DENSYUBETU)を組み合わせ表のコード体系に正規化します。
// 画面入力値 0～3 を、仕入/返品/値引/値増に対応する 01～04 へ丸めます。
function normalizeRawPurchaseEntrySlipTypeCode(value) {
    const normalized = String(value ?? "").trim();
    if (normalized === "0") return "01";
    if (normalized === "1") return "02";
    if (normalized === "2") return "03";
    if (normalized === "3") return "04";
    return normalized;
}

// 伝票区分(ZSR_DENKBN)を比較用の文字列へ正規化します。
function normalizeRawPurchaseEntrySlipCategoryCode(value) {
    const normalized = String(value ?? "").trim();
    return normalized;
}

// 区分・仕入種別・伝票種別・伝票区分を1つのキーにまとめます。
// 参照元組み合わせ表の1行を一意に探すための内部キーです。
function buildRawPurchaseEntryReferenceRuleKey(materialCategoryCode, purchaseKindCode, slipTypeCode, slipCategoryCode) {
    return [
        normalizeRawPurchaseEntryMaterialCategoryCode(materialCategoryCode),
        normalizeRawPurchaseEntryPurchaseKindCode(purchaseKindCode),
        normalizeRawPurchaseEntrySlipTypeCode(slipTypeCode),
        normalizeRawPurchaseEntrySlipCategoryCode(slipCategoryCode)
    ].join("|");
}

// 現在の入力値に一致する参照元組み合わせルールだけを抽出します。
function filterRawPurchaseEntryReferenceRules(materialCategoryCode, purchaseKindCode, slipTypeCode, slipCategoryCode) {
    const ruleKey = buildRawPurchaseEntryReferenceRuleKey(materialCategoryCode, purchaseKindCode, slipTypeCode, slipCategoryCode);
    return RAW_PURCHASE_ENTRY_REFERENCE_RULES.filter(rule =>
        buildRawPurchaseEntryReferenceRuleKey(
            rule.materialCategoryCode,
            rule.purchaseKindCode,
            rule.slipTypeCode,
            rule.slipCategoryCode) === ruleKey
    );
}

// 現在の区分・仕入種別・伝票種別・伝票区分から許可される参照元伝票区分を求めます。
// NEW FORM の 100番台パネルで ZSR_SANMOTODENKBN の選択肢を制限するために使います。
function resolveRawPurchaseEntryAllowedSourceCategoryCodes(materialCategoryCode, purchaseKindCode, slipTypeCode, slipCategoryCode) {
    const sourceCategoryCodes = [];
    filterRawPurchaseEntryReferenceRules(materialCategoryCode, purchaseKindCode, slipTypeCode, slipCategoryCode).forEach(rule => {
        const normalized = normalizeRawPurchaseEntrySourceCategoryCode(rule.sourceCategoryCode);
        if (normalized === "") return;
        if (sourceCategoryCodes.indexOf(normalized) !== -1) return;
        sourceCategoryCodes.push(normalized);
    });
    return sourceCategoryCodes;
}

// 参照元伝票区分が既知だが Entry 画面未実装かどうかを判定します。
// 発注(4)など対象外になった画面へ遷移しないためのガードです。
export function isKnownButUnimplementedRawPurchaseEntrySourceCategoryCode(sourceCategoryCode) {
    const normalized = normalizeRawPurchaseEntrySourceCategoryCode(sourceCategoryCode);
    if (!Object.prototype.hasOwnProperty.call(RAW_PURCHASE_ENTRY_ROUTE_DEFINITIONS, normalized)) {
        return false;
    }
    return RAW_PURCHASE_ENTRY_ROUTE_DEFINITIONS[normalized].implemented !== true;
}

// 区分コードごとの明細パネル種別を作ります。
// 100/300/500/600/700/900番台それぞれで、素材・附属・副資材の s_lo_type を対応付けます。
export function buildRawPurchaseEntryDetailPanelTypes(materialPanelType, accessoryPanelType, subMaterialPanelType) {
    return {
        "1": materialPanelType,
        "2": accessoryPanelType,
        "3": subMaterialPanelType
    };
}

// 区分コードごとに非表示にする明細パネル種別を作ります。
// 区分が素材なら附属・副資材を隠す、という画面設計書のパネル切替を共通化します。
export function buildRawPurchaseEntryHiddenPanelTypes(materialPanelType, accessoryPanelType, subMaterialPanelType) {
    return {
        "1": [accessoryPanelType, subMaterialPanelType],
        "2": [materialPanelType, subMaterialPanelType],
        "3": [materialPanelType, accessoryPanelType]
    };
}

// 区分別の合計パネル種別と計算式を作ります。
// 明細（素材/附属/副資材）ごとの合計行を、各参照元画面の s_lo_type に合わせて生成します。
export function buildRawPurchaseEntryTotalPanelDefinitions(materialTotalType, accessoryTotalType, subMaterialTotalType) {
    return {
        [materialTotalType]: {
            calculations: rawPurchaseEntryTotalCalculationsZai
        },
        [accessoryTotalType]: {
            calculations: rawPurchaseEntryTotalCalculationsOther
        },
        [subMaterialTotalType]: {
            calculations: rawPurchaseEntryTotalCalculationsOther
        }
    };
}

// 現在の Entry データに参照元伝票番号(ZSR_SANSYODENNO)があるかを判定します。
// 参照元がある場合のヘッダー固定や明細編集禁止の判定に使います。
export function hasRawPurchaseEntryReference(context) {
    if (isEmpty(context?.entrydataRef?.current)) return false;
    return String(context.entrydataRef.current[RAW_PURCHASE_ENTRY_FIELD_IDS.referenceSlipNo] ?? "").trim() !== "";
}

// s_layout由来の項目定義を、カラムIDとパネル種別で比較するためのキーにします。
function rawPurchaseEntryFieldKey(field) {
    return String(DicVal(field, "columnid", "") ?? "") + "|" + String(DicVal(field, "type", "") ?? "");
}

// ロックや選択肢更新の対象カラムID配列から空値と重複を取り除きます。
function normalizeRawPurchaseEntryTargetColumnIds(targetColumnIds) {
    if (!Array.isArray(targetColumnIds)) return [];

    const uniqueColumnIds = [];
    targetColumnIds.forEach(columnId => {
        const normalizedColumnId = String(columnId ?? "").trim();
        if (normalizedColumnId === "" || uniqueColumnIds.includes(normalizedColumnId)) return;
        uniqueColumnIds.push(normalizedColumnId);
    });
    return uniqueColumnIds;
}

// ZSR_SANMOTODENKBN などの選択肢配列が実質的に同じか比較します。
// 不要な state 更新を避け、入力中の再描画を抑えるための判定です。
export function areRawPurchaseEntryFieldOptionsEqual(leftOptions, rightOptions) {
    const left = Array.isArray(leftOptions) ? leftOptions : [];
    const right = Array.isArray(rightOptions) ? rightOptions : [];
    if (left === right) return true;
    if (left.length !== right.length) return false;

    for (let i = 0; i < left.length; i++) {
        const leftOption = isEmpty(left[i]) ? {} : left[i];
        const rightOption = isEmpty(right[i]) ? {} : right[i];
        const leftKeys = Object.keys(leftOption);
        const rightKeys = Object.keys(rightOption);
        if (leftKeys.length !== rightKeys.length) return false;

        for (let j = 0; j < leftKeys.length; j++) {
            const key = leftKeys[j];
            if (!Object.prototype.hasOwnProperty.call(rightOption, key)) return false;
            if (leftOption[key] !== rightOption[key]) return false;
        }
    }
    return true;
}

// 現在の項目定義のうち指定カラムだけを、元定義を参照しながら差し替えます。
// 参照元ありのヘッダーロックや参照元候補制限を s_layout 項目に反映します。
export function buildUpdatedRawPurchaseEntryFields(currentFields, sourceFields, targetColumnIds, buildNextField) {
    if (!Array.isArray(currentFields) || currentFields.length === 0) return null;
    if (!Array.isArray(sourceFields) || sourceFields.length === 0) return null;
    if (typeof buildNextField !== "function") return null;

    const normalizedTargetColumnIds = normalizeRawPurchaseEntryTargetColumnIds(targetColumnIds);
    if (normalizedTargetColumnIds.length === 0) return null;

    const targetColumnIdSet = new Set(normalizedTargetColumnIds);
    const sourceFieldMap = new Map();
    sourceFields.forEach(field => {
        sourceFieldMap.set(rawPurchaseEntryFieldKey(field), field);
    });

    let nextFields = null;
    currentFields.forEach((field, index) => {
        if (!targetColumnIdSet.has(String(DicVal(field, "columnid", "") ?? ""))) return;

        const nextField = buildNextField(field, sourceFieldMap.get(rawPurchaseEntryFieldKey(field)));
        if (isEmpty(nextField) || nextField === field) return;

        if (nextFields === null) {
            nextFields = currentFields.slice();
        }
        nextFields[index] = nextField;
    });

    return nextFields;
}

// 参照元伝票番号そのものを手入力している最中かを判定します。
// 入力中にロック処理を走らせて操作を邪魔しないための除外条件です。
function isEditingRawPurchaseEntryReferenceSlipNo(context) {
    return context.reason === "base-value-changed"
        && context.changedColumnId === RAW_PURCHASE_ENTRY_FIELD_IDS.referenceSlipNo
        && context.edit === true;
}

// 参照元伝票がある場合に、指定されたヘッダー項目を編集不可にします。
// 社内売買などの「継承した参照元データは変更不可」をフロント側で表現します。
export function applyRawPurchaseEntryReferenceHeaderLocks(context, headerLockColumnIds) {
    if (isEditingRawPurchaseEntryReferenceSlipNo(context)) return;

    const currentFields = Array.isArray(context.textfieldsall) ? context.textfieldsall : [];
    const sourceFields = Array.isArray(context.originalTextfieldsall) && context.originalTextfieldsall.length !== 0
        ? context.originalTextfieldsall
        : currentFields;
    if (!Array.isArray(sourceFields) || sourceFields.length === 0 || currentFields.length === 0) return;

    const targetColumnIds = normalizeRawPurchaseEntryTargetColumnIds(headerLockColumnIds);
    if (targetColumnIds.length === 0) return;

    const hasReference = hasRawPurchaseEntryReference(context);
    const nextFields = buildUpdatedRawPurchaseEntryFields(currentFields, sourceFields, targetColumnIds, (field, originalField) => {
        const nextLocked = hasReference
            ? true
            : DicVal(originalField, "locked", false) === true;
        const currentLocked = DicVal(field, "locked", false) === true;
        if (currentLocked === nextLocked) return field;
        return {
            ...field,
            locked: nextLocked
        };
    });

    if (nextFields !== null) {
        context.ReplaceBaseFields(nextFields);
    }
}

// 参照元つき Entry 画面で使う共通フックを作ります。
// ヘッダーロック、明細セル編集可否、行追加・挿入・削除禁止をまとめて派生画面へ渡します。
export function buildRawPurchaseEntryReferenceHooks(headerLockColumnIds, detailEditWarningMessage) {
    const warningMessage = String(detailEditWarningMessage ?? "").trim() === ""
        ? "参照元の明細は編集できません"
        : String(detailEditWarningMessage ?? "").trim();

    // 参照元あり画面のヘッダーロックなど、画面全体にかかる規則を適用します。
    function applyScreenRules(context) {
        applyRawPurchaseEntryReferenceHeaderLocks(context, headerLockColumnIds);
    }

    // 参照元あり画面で明細セルを編集できるかを返します。
    // 戻り値は EntryGridAr の lockcell に渡され、参照元明細の変更を抑止します。
    function gridLockCell(context) {
        if (hasRawPurchaseEntryReference(context)) {
            return false;
        }
        return context.edit;
    }

    // 参照元から継承した明細に対する行追加・挿入・削除を止めます。
    // 画面設計書備考の「継承した参照元データは変更不可」を実現します。
    function blockDetailEdit(context) {
        if (!hasRawPurchaseEntryReference(context)) return true;
        if (context.rowcount === undefined || context.rowcount === null) {
            context.fnc.current.warnmsg(warningMessage);
        }
        return false;
    }

    return {
        applyScreenRules: applyScreenRules,
        gridLockCell: gridLockCell,
        queryAddRow: blockDetailEdit,
        queryInsertRow: blockDetailEdit,
        queryRemoveRow: blockDetailEdit
    };
}

// RawPurchaseEntryXxx で共通利用する Entry 画面です。
// 画面定義は派生コントローラー名、データ保存先は RawPurchase 本体に分離しています。
// 原材料仕入入力の各参照元 Entry 画面が共有する本体コンポーネントです。
// 派生ファイルの entryConfig により、100番台/300番台/500番台/600番台/700番台/900番台の画面定義と処理を切り替えます。
export const RawPurchaseEntryBase = React.forwardRef((props, ref) => {
    const config = props.entryConfig || {};
    const entryHooks = config.entryHooks || {};
    const embedded = props.embedded === true;
    const screenId = config.screenId || "RawPurchaseEntryBase";
    const apiController = config.apiController || screenId;
    const dataController = config.dataController || "RawPurchase";
    const layoutController = config.layoutController || dataController;
    const formKey = config.formKey || screenId;
    const listController = config.listController || "RawPurchase";
    const callerIdentifier = config.callerIdentifier || "RawPurchase";
    const sourceCategoryCode = Object.prototype.hasOwnProperty.call(config, "sourceCategoryCode")
        ? String(config.sourceCategoryCode ?? "")
        : "7";
    const primarykeys = config.primarykeys || ["ZSR_DENNO"];
    const sourceCategoryColumnId = config.sourceCategoryColumnId || RAW_PURCHASE_ENTRY_FIELD_IDS.sourceCategoryCode;
    const materialCategoryColumnId = config.materialCategoryColumnId || "";
    const materialCategoryStateKeys = config.materialCategoryStateKeys || [];
    const detailPanelTypesByMaterialCategory = config.detailPanelTypesByMaterialCategory || {};
    const carryoverClearColumnIds = config.carryoverClearColumnIds || [
        RAW_PURCHASE_ENTRY_FIELD_IDS.slipNo,
        RAW_PURCHASE_ENTRY_FIELD_IDS.referenceSlipNo
    ];
    const hiddenPanelTypesByMaterialCategory = config.hiddenPanelTypesByMaterialCategory || {};
    const totalPanelDefinitions = config.totalPanelDefinitions || {};
    const materialCategoryControlledPanelTypes = [];
    Object.keys(hiddenPanelTypesByMaterialCategory).forEach(key => {
        const panelTypes = hiddenPanelTypesByMaterialCategory[key];
        if (!Array.isArray(panelTypes)) return;
        panelTypes.forEach(panelType => {
            const normalized = String(panelType ?? "").trim();
            if (normalized === "") return;
            if (materialCategoryControlledPanelTypes.indexOf(normalized) !== -1) return;
            materialCategoryControlledPanelTypes.push(normalized);
        });
    });

    const panelsdef = [];
    const G_id = { BASE: "0", IMAGE: "pic", NB: "nb" };
    const formid = getformid(formKey, props.location.search);
    const controller = getcontroller(layoutController, props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const formListOption = useSelector(state => state.form.listoption);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);
    const formstatus = useSelector(state => state.form.status);
    const gridlist = useSelector(state => state.form.gridlist);

    const dispatch = useDispatch();
    const history = useHistory();
    const search = useLocation().search;
    const fnc = useRef();
    const AGRef = useRef();
    const EntrybodyRef = useRef(null);
    const locationstate = useRef(null);
    const activeCallerControllerRef = useRef(listController);
    const initialLoadStartedRef = useRef(false);
    const mountedRef = useRef(true);
    const formstatusRef = useRef(formstatus);
    const modifyRef = useRef(false);
    const originalModifyHandlerRef = useRef(null);
    const originalMasterDataHandlerRef = useRef(null);
    const originalSearchListOpenHandlerRef = useRef(null);
    const wrappedMasterDataHandlerRef = useRef(null);
    const wrappedSearchListOpenHandlerRef = useRef(null);
    const sourceCategoryNavigationReadyRef = useRef(false);
    const sourceCategoryFieldControlTimerRef = useRef(null);
    const sourceCategorySelectionTimerRef = useRef(null);
    const closeWaitAfterRenderTimerRef = useRef(null);
    const panelRef = useRef(panelsdef);
    const gridListRef = useRef([]);
    const gridIndexMapRef = useRef(new Map());
    const baseFieldSourceRef = useRef([]);
    const embeddedNavmenuSignatureRef = useRef("");

    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState("");
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [update, setUpdata] = useState(false);

    const effectiveListOption = embedded && Array.isArray(props.sharedListOption)
        ? props.sharedListOption
        : formListOption;

    const gridapiRefs = useRef([]);
    const gridcolapiRefs = useRef([]);
    const griddataRefs = useRef([]);
    const gridcolRefs = useRef([]);

    const localEntrydataRef = useRef(null);
    const entrydataRef = embedded && !isEmpty(props.sharedEntrydataRef)
        ? props.sharedEntrydataRef
        : localEntrydataRef;
    const imageRef = useRef([]);

    const suppressaction = [];
    const navmenu = [];

    // 入力フォームを明示的に再描画させるためのトグル更新です。
    function rerender() {
        setUpdata(update ? false : true);
    }

    // Entry 画面で現在扱っている原材料仕入伝票番号を取得します。
    function CurrentSlipNo() {
        const code = String(edittingcode ?? "").trim();
        if (code !== "") return code;
        return String(DicVal(entrydataRef.current, "ZSR_DENNO", "")).trim();
    }

    // 申請解除メニューの表示条件を判定します。
    function ShowWithdrawMenu() {
        if (CurrentSlipNo() === "") return false;
        const reqFlg = String(DicVal(entrydataRef.current, "ZSR_REQFLG", "")).trim();
        const synFlg1 = String(DicVal(entrydataRef.current, "ZSR_SYNFLG1", "")).trim();
        return reqFlg === "1" && (synFlg1 === "0" || synFlg1 === "1");
    }

    // 埋め込み Entry 画面で親へ返すコマンドメニューを組み立てます。
    function BuildEmbeddedEntryNavmenu() {
        const nextNavmenu = [
            { status: "ENTRY FORM", menuid: "bulkcreate", icon: "open_in_new", label: "原材料支給一括作成" },
            { status: "ENTRY FORM", menuid: "sep" },
            { status: "ENTRY FORM", menuid: "print1", icon: "print", label: "原材料仕入伝票発行" },
        ];

        if (ShowWithdrawMenu()) {
            nextNavmenu.push({ status: "ENTRY FORM", menuid: "sep" });
            nextNavmenu.push({ status: "ENTRY FORM", menuid: "withdraw", icon: "cancel", label: "申請解除" });
        }

        return nextNavmenu;
    }

    // 親 RawPurchase に Entry 用メニューだけを通知します。
    function NotifyEmbeddedNavmenu() {
        if (!embedded) return;
        if (typeof props.onEntryNavmenuChange !== "function") return;

        const nextNavmenu = BuildEmbeddedEntryNavmenu();
        const nextSignature = JSON.stringify(nextNavmenu);
        if (embeddedNavmenuSignatureRef.current === nextSignature) return;

        embeddedNavmenuSignatureRef.current = nextSignature;
        props.onEntryNavmenuChange(nextNavmenu);
    }

    // 取得または復元したパネル一覧から、現在の参照元画面に該当する s_lo_type だけを残して state に反映します。
    function UpdatePanels(nextPanels) {
        const filteredPanels = FilterCurrentScreenPanels(nextPanels);
        panelRef.current = filteredPanels;
        setpanel(filteredPanels);
    }

    // ヘッダー項目定義をカラムID・種別キーで参照できる Map にします。
    function BuildBaseFieldMap(fields) {
        const fieldMap = new Map();
        const sourceFields = Array.isArray(fields) ? fields : [];
        sourceFields.forEach(field => {
            fieldMap.set(rawPurchaseEntryFieldKey(field), field);
        });
        return fieldMap;
    }

    // ヘッダー項目定義を差し替え、表示中項目と entrydataRef の形も同期します。
    // 参照元候補制限やロック状態変更を画面へ反映する入口です。
    function ReplaceBaseFields(nextFields) {
        if (!Array.isArray(nextFields)) return;
        const normalizedFields = nextFields.map(field => NormalizeBaseFieldDefinition(field));
        const normalizedFieldMap = BuildBaseFieldMap(normalizedFields);

        if (!isEmpty(entrydataRef.current)) {
            entrydataRef.current = NormalizeEntryDataShape(entrydataRef.current, normalizedFields);
        }

        const visibleKeys = textfields.map(field => field.columnid + "|" + field.type);
        const nextVisible = [];
        visibleKeys.forEach(key => {
            const field = normalizedFieldMap.get(key);
            if (!isEmpty(field)) nextVisible.push(field);
        });

        settextfieldsall(normalizedFields);
        settextfields(nextVisible);
    }

    // 明細・合計グリッドのパネル情報と配列インデックス対応を保存します。
    // EntryGridAr の API/ref を s_logp パネル単位で引けるようにします。
    function UpdateGridList(nextGridList) {
        gridListRef.current = nextGridList;
        const nextIndexMap = new Map();
        if (Array.isArray(nextGridList)) {
            nextGridList.forEach((gridInfo, index) => {
                if (isEmpty(gridInfo)) return;
                const id = String(DicVal(gridInfo, "id", "")).trim();
                const type = String(DicVal(gridInfo, "type", "")).trim();
                if (id === "") return;
                nextIndexMap.set(id + "|" + type, index);
                if (type === "" && !nextIndexMap.has(id)) {
                    nextIndexMap.set(id, index);
                }
            });
        }
        gridIndexMapRef.current = nextIndexMap;
        dispatch(setgridlist(nextGridList));
    }

    // 現在の参照元画面に対応する s_lo_type の先頭値を返します。
    // 参照元なしは 100番台、社内売買は 600番台のようにパネルを絞り込みます。
    function CurrentLayoutTypePrefix() {
        const normalized = normalizeRawPurchaseEntrySourceCategoryCode(sourceCategoryCode);
        return normalized === "" ? "1" : normalized;
    }

    // 指定された s_lo_type が現在の Entry 画面に属するかを判定します。
    function IsCurrentScreenType(type) {
        const normalized = String(type ?? "").trim();
        if (normalized === "") return true;
        return normalized.startsWith(CurrentLayoutTypePrefix());
    }

    // s_logp のパネル一覧から現在の参照元画面に必要なパネルだけを抽出します。
    function FilterCurrentScreenPanels(panels) {
        if (!Array.isArray(panels)) return [];
        return panels.filter(panelInfo => IsCurrentScreenType(DicVal(panelInfo, "type", "")));
    }

    // s_layout の項目一覧から現在の参照元画面に必要な項目だけを抽出します。
    function FilterCurrentScreenColumns(columns) {
        if (!Array.isArray(columns)) return [];
        return columns.filter(columnInfo => IsCurrentScreenType(DicVal(columnInfo, "type", "")));
    }

    // GetListTabs のレスポンスから、現在の参照元 Entry 画面で使用する情報だけを残します。
    // RawPurchase は List と複数種類の Entry の画面定義を同じ controller で取得するため、
    // 受信直後に不要な s_lo_type の情報を捨て、後続の master 初期化や Redux 更新を軽くします。
    function BuildCurrentScreenLayoutData(data) {
        if (isEmpty(data)) return data;

        const filteredPanels = FilterCurrentScreenPanels(data.panels);
        const filteredColInfo = FilterCurrentScreenColumns(data.colinfo);
        const filteredColumns = FilterCurrentScreenColumns(data.columns);

        const isCurrentTypeItem = function (item) {
            if (isEmpty(item)) return false;

            const type = !isEmpty(DicVal(item, "type", "")) ? DicVal(item, "type", "")
                : !isEmpty(DicVal(item, "s_lo_type", "")) ? DicVal(item, "s_lo_type", "")
                    : !isEmpty(DicVal(item, "s_logp_type", "")) ? DicVal(item, "s_logp_type", "")
                        : "";

            return IsCurrentScreenType(type);
        };

        return {
            ...data,
            panels: filteredPanels,
            colinfo: filteredColInfo,
            columns: filteredColumns,

            // 配列で返ってくる情報だけ現在画面の type に絞ります。
            // 配列でない情報は共通機能側の形式を壊さないよう、そのまま渡します。
            layouts: Array.isArray(data.layouts) ? data.layouts.filter(isCurrentTypeItem) : data.layouts,
            prelayout: Array.isArray(data.prelayout) ? data.prelayout.filter(isCurrentTypeItem) : data.prelayout,
            initlayout: Array.isArray(data.initlayout) ? data.initlayout.filter(isCurrentTypeItem) : data.initlayout,
            fitColumn: Array.isArray(data.fitColumn) ? data.fitColumn.filter(isCurrentTypeItem) : data.fitColumn,
            tabs: Array.isArray(data.tabs) ? data.tabs.filter(isCurrentTypeItem) : data.tabs,
            master: Array.isArray(data.master) ? data.master.filter(isCurrentTypeItem) : data.master,
            listoption: Array.isArray(data.listoption) ? data.listoption.filter(isCurrentTypeItem) : data.listoption
        };
    }

    // s_layout の selectlist をローカル候補として扱うデータ種別か判定します。
    // 参照元候補など、マスタ再検索ではなく画面側で候補を差し替える項目に使います。
    function IsLocalOptionField(field) {
        if (isEmpty(field)) return false;
        if (!Array.isArray(field.options) || field.options.length === 0) return false;
        return field.datatype === "4"
            || field.datatype === "13"
            || field.datatype === "14"
            || field.datatype === "15"
            || field.datatype === "16";
    }

    // ヘッダー項目定義を Entry 画面用に補正します。
    // ZSR_SANSYODENNO を入力可能にし、ローカル候補項目は dataid を空にして共通マスタ検索を避けます。
    function NormalizeBaseFieldDefinition(field) {
        if (isEmpty(field)) return field;
        let nextField = { ...field };

        if (nextField.columnid === RAW_PURCHASE_ENTRY_FIELD_IDS.referenceSlipNo) {
            nextField.locked = false;
            nextField.unchange = false;
            nextField.primary = false;
        }

        if (IsLocalOptionField(nextField)) {
            nextField.dataid = "";
            nextField.dataidctrl = "";
        }

        return nextField;
    }

    // 全ヘッダー項目定義と表示列設定から、現在表示する基本情報項目を作ります。
    function BuildVisibleBaseFields(sourceFields, visibleColumns) {
        const baseFields = Array.isArray(sourceFields) ? sourceFields : [];
        const baseFieldMap = new Map();
        baseFields.forEach(field => {
            const key = [
                String(DicVal(field, "table", "")),
                String(DicVal(field, "columnid", "")),
                String(DicVal(field, "type", "")),
                String(DicVal(field, "logpid", ""))
            ].join("|");
            baseFieldMap.set(key, field);
        });
        const visibleBaseColumns = Array.isArray(visibleColumns)
            ? visibleColumns.filter(column => String(DicVal(column, "logpid", "")) === G_id.BASE)
            : [];

        return visibleBaseColumns.map(column => {
            const sourceField = baseFieldMap.get([
                String(DicVal(column, "table", "")),
                String(DicVal(column, "columnid", "")),
                String(DicVal(column, "type", "")),
                String(DicVal(column, "logpid", ""))
            ].join("|"));

            if (isEmpty(sourceField)) {
                return NormalizeBaseFieldDefinition(column);
            }

            return NormalizeBaseFieldDefinition({
                ...sourceField,
                width: DicVal(column, "width", DicVal(sourceField, "width", 0)),
                hide: DicVal(column, "hide", DicVal(sourceField, "hide", "0")),
                pin: DicVal(column, "pin", DicVal(sourceField, "pin", false)),
                seqno: DicVal(column, "seqno", DicVal(sourceField, "seqno", 0))
            });
        });
    }

    // GetData/Insert/Update に渡す項目定義を、全ソースから重複なしで組み立てます。
    // 表示中以外のパネルや保存に必要な列もサーバーへ渡せるようにします。
    function BuildRequestColumnInfo() {
        const merged = [];
        const keys = new Set();
        const sources = [columninfo, columns, textfieldsall, baseFieldSourceRef.current];

        sources.forEach(items => {
            if (!Array.isArray(items)) return;
            items.forEach(item => {
                if (isEmpty(item)) return;
                const key = [
                    DicVal(item, "table", ""),
                    DicVal(item, "type", ""),
                    DicVal(item, "logpid", ""),
                    DicVal(item, "columnid", "")
                ].join("|");
                if (keys.has(key)) return;
                keys.add(key);
                merged.push(item);
            });
        });

        return merged;
    }

    // 最新のグリッド一覧を ref 優先で返します。
    // Redux state とのタイミング差で明細パネルが見つからない問題を避けます。
    function CurrentGridList() {
        if (Array.isArray(gridListRef.current) && gridListRef.current.length !== 0) {
            return gridListRef.current;
        }
        return Array.isArray(gridlist) ? gridlist : [];
    }

    // 指定パネルに対応する列定義を、s_lo_type 優先で解決します。
    function ResolvePanelColumnInfo(panelInfo, sourceColumnInfo = columninfo) {
        if (isEmpty(panelInfo) || !Array.isArray(sourceColumnInfo)) return [];

        const panelType = String(DicVal(panelInfo, "type", "")).trim();
        const panelId = String(DicVal(panelInfo, "id", "")).trim();

        const matchedByType = sourceColumnInfo.filter(column =>
            String(DicVal(column, "type", "")).trim() === panelType);
        if (matchedByType.length !== 0) return matchedByType;

        if (panelId === "") return [];
        return sourceColumnInfo.filter(column =>
            String(DicVal(column, "logpid", "")).trim() === panelId);
    }

    // 指定パネルで表示する列設定を、s_lo_type 優先で解決します。
    function ResolvePanelVisibleColumns(panelInfo, sourceColumns = columns) {
        if (isEmpty(panelInfo) || !Array.isArray(sourceColumns)) return [];

        const panelType = String(DicVal(panelInfo, "type", "")).trim();
        const panelId = String(DicVal(panelInfo, "id", "")).trim();

        const matchedByType = sourceColumns.filter(column =>
            String(DicVal(column, "type", "")).trim() === panelType);
        if (matchedByType.length !== 0) return matchedByType;

        if (panelId === "") return [];
        return sourceColumns.filter(column =>
            String(DicVal(column, "logpid", "")).trim() === panelId);
    }

    // AGFunction を使って、指定パネルの AG Grid 列定義を生成します。
    function CreatePanelColDef(panelInfo, sourceColumnInfo = columninfo, sourceColumns = columns) {
        if (isEmpty(AGRef.current) || typeof AGRef.current.createColDef !== "function") return [];
        const panelColumnInfo = ResolvePanelColumnInfo(panelInfo, sourceColumnInfo);
        if (panelColumnInfo.length === 0) return [];
        return AGRef.current.createColDef(panelColumnInfo, ResolvePanelVisibleColumns(panelInfo, sourceColumns), false);
    }

    // パネルIDと種別から、gridapiRefs などの配列インデックスを解決します。
    function GridIndex(panelInfo) {
        const currentIndexMap = gridIndexMapRef.current;
        const currentGridList = CurrentGridList();
        if (typeof panelInfo !== "object") {
            const key = String(panelInfo ?? "").trim();
            if (key !== "" && currentIndexMap instanceof Map && currentIndexMap.has(key)) {
                return currentIndexMap.get(key);
            }
            if (currentGridList.some(e => e.id === panelInfo)) {
                return currentGridList.find(e => e.id === panelInfo).index;
            }
            return -1;
        }
        const id = String(DicVal(panelInfo, "id", "")).trim();
        const type = String(DicVal(panelInfo, "type", "")).trim();
        const exactKey = id + "|" + type;
        if (currentIndexMap instanceof Map && currentIndexMap.has(exactKey)) {
            return currentIndexMap.get(exactKey);
        }
        if (type === "" && currentIndexMap instanceof Map && currentIndexMap.has(id)) {
            return currentIndexMap.get(id);
        }
        if (currentGridList.some(e => e.id === panelInfo.id && e.type === panelInfo.type)) {
            return currentGridList.find(e => e.id === panelInfo.id && e.type === panelInfo.type).index;
        }
        if (isEmpty(panelInfo.type) && currentGridList.some(e => e.id === panelInfo.id)) {
            return currentGridList.find(e => e.id === panelInfo.id).index;
        }
        return -1;
    }

    // 指定パネルの明細データ ref に行配列を保存します。
    function SetGridData(panelInfo, data) {
        let gidx = GridIndex(panelInfo);
        if (gidx === -1) return;
        if (isEmpty(griddataRefs.current[gidx])) return;
        griddataRefs.current[gidx].current = data;
    }
    // 指定パネルの明細データ ref と AG Grid 表示を同時に更新します。
    function ApplyGridData(panelInfo, data) {
        SetGridData(panelInfo, data);

        const api = GridApi(panelInfo);
        if (!IsAvailableGridApi(api)) return;

        const rows = Array.isArray(data) ? data : [];
        if (typeof api.setGridOption === "function") {
            api.setGridOption('rowData', rows);
            return;
        }
        if (typeof api.setRowData === "function") {
            api.setRowData(rows);
        }
    }
    // 指定パネルの現在の明細データを返します。
    function GridData(panelInfo) {
        let gidx = GridIndex(panelInfo);
        if (gidx === -1) return null;
        if (isEmpty(griddataRefs.current[gidx])) return null;
        return griddataRefs.current[gidx].current;
    }
    // 指定パネルの列定義 ref を更新します。
    function SetGridColDef(panelInfo, coldef) {
        let gidx = GridIndex(panelInfo);
        if (gidx === -1) return;
        if (isEmpty(gridcolRefs.current[gidx])) return;
        gridcolRefs.current[gidx].current = coldef;
    }
    // 指定パネルの AG Grid API ref を保存します。
    function SetGridApi(panelInfo, api) {
        let gidx = GridIndex(panelInfo);
        if (gidx === -1) return;
        if (isEmpty(gridapiRefs.current[gidx])) return;
        gridapiRefs.current[gidx].current = api;
    }
    // 指定パネルの AG Grid API を返します。
    function GridApi(panelInfo) {
        let gidx = GridIndex(panelInfo);
        if (gidx === -1) return null;
        if (isEmpty(gridapiRefs.current[gidx])) return null;
        return gridapiRefs.current[gidx].current;
    }
    // AG Grid API が存在し、破棄済みでないかを判定します。
    function IsAvailableGridApi(api) {
        if (isEmpty(api)) return false;
        if (typeof api.isDestroyed === "function" && api.isDestroyed()) return false;
        return true;
    }
    // 指定パネルの Column API ref を保存します。
    function SetGridColApi(panelInfo, api) {
        let gidx = GridIndex(panelInfo);
        if (gidx === -1) return;
        if (isEmpty(gridcolapiRefs.current[gidx])) return;
        gridcolapiRefs.current[gidx].current = api;
    }
    // 指定パネルの Column API を返します。
    function GridColApi(panelInfo) {
        let gidx = GridIndex(panelInfo);
        if (gidx === -1) return null;
        if (isEmpty(gridcolapiRefs.current[gidx])) return null;
        return gridcolapiRefs.current[gidx].current;
    }

    // パネルIDが T で始まる合計パネルかを判定します。
    function IsTotalGrid(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        return String(DicVal(panelInfo, "id", "")).startsWith("T");
    }

    // 合計パネルを除いた明細グリッド一覧を返します。
    function DetailGridList() {
        return CurrentGridList().filter(e => !IsTotalGrid(e));
    }

    // 指定パネルのグリッドを再描画します。
    function RefreshGrid(panelInfo) {
        if (isEmpty(fnc.current)) return;
        if (!IsAvailableGridApi(GridApi(panelInfo))) return;
        fnc.current.rerenderGrid(fnc.current.GridID(panelInfo));
    }

    // すべての明細グリッドを再描画します。
    function RefreshAllDetailGrids() {
        DetailGridList().forEach(panelInfo => {
            RefreshGrid(panelInfo);
        });
    }

    // 区分コードから、現在表示対象の明細パネル情報を探します。
    function DetailPanelInfoByMaterialCategory(materialCategoryCode) {
        const panelType = String(DicVal(detailPanelTypesByMaterialCategory, materialCategoryCode, "") ?? "").trim();
        if (panelType === "") return null;
        return DetailGridList().find(panelInfo => String(DicVal(panelInfo, "type", "")).trim() === panelType) ?? null;
    }

    // 明細パネルに対応する合計パネルがあるかを判定します。
    function HasTotalPanel(panelInfo) {
        return !isEmpty(panelInfo) && !isEmpty(DicVal(panelInfo, "totaltype", ""));
    }

    // 明細パネルから対応する合計パネルのID・種別を作ります。
    function ResolveTotalPanelInfo(panelInfo) {
        if (!HasTotalPanel(panelInfo)) return null;
        const totalType = String(DicVal(panelInfo, "totaltype", "")).trim();
        if (totalType === "") return null;
        return { id: "T" + panelInfo.id, type: totalType };
    }

    // 合計パネルの計算定義を取得します。
    // 素材/附属/副資材ごとの数量・金額合計計算に使います。
    function ResolveTotalPanelDefinition(panelInfo) {
        const totalPanelInfo = ResolveTotalPanelInfo(panelInfo);
        if (isEmpty(totalPanelInfo)) return null;

        if (Array.isArray(totalPanelDefinitions)) {
            const target = totalPanelDefinitions.find(e => String(DicVal(e, "totalType", "")).trim() === totalPanelInfo.type);
            return isEmpty(target) ? null : target;
        }

        return DicVal(totalPanelDefinitions, totalPanelInfo.type, null);
    }

    // 出荷実績参照で追加するカット代行は、画面設計書上「必要なときだけ手動追加する」運用です。
    // 最終行へ値を入れた時の共通自動行追加をそのまま使うと、入力のたびに次のカット代行が増えてしまうため、
    // この画面では出荷実績参照中の明細パネルだけ AutoAddRow を止めます。
    function ShouldDisableDetailAutoAddRow(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        if (String(DicVal(panelInfo, "id", "")).startsWith("T")) return false;
        const panelType = String(DicVal(panelInfo, "type", "")).trim();
        if (!Object.values(detailPanelTypesByMaterialCategory).includes(panelType)) return false;
        if (CurrentSourceCategoryCode() !== "3") return false;
        return String(DicVal(entrydataRef.current, RAW_PURCHASE_ENTRY_FIELD_IDS.referenceSlipNo, "") ?? "").trim() !== "";
    }

    // 合計パネルの初期行を作ります。
    // 合計値は0、表示ラベルは「計」として初期化します。
    function DefaultTotalRows(panelInfo) {
        const totalRow = { rowid: "TOTAL", grip: "計" };
        const definition = ResolveTotalPanelDefinition(panelInfo);
        if (!isEmpty(definition) && Array.isArray(definition.calculations)) {
            definition.calculations.forEach(calculation => {
                const targetColumnId = String(DicVal(calculation, "targetColumnId", "")).trim();
                if (targetColumnId !== "") totalRow[targetColumnId] = 0;
            });
        }
        return [totalRow];
    }

    // 計算式評価用の数値変換
    // カンマ付き文字列が来ても計算できるようにここで吸収する
    // 1行分の式を評価し、その結果を合計へ加算します。
    // 明細1行に対して合計計算式を評価します。
    // ZSRM_SIIREMETERSU * ZSRM_TANKAF など、設計書の合計欄に出す値を計算します。
    function EvaluateRowFormula(row, rowFormula) {
        if (!Array.isArray(rowFormula) || rowFormula.length === 0) return 0;

        const tokens = rowFormula.map(token => {
            if (typeof token === "number") return token;

            const text = String(token ?? "").trim();
            if (text === "+" || text === "-" || text === "*" || text === "/") return text;
            if (text !== "" && !Number.isNaN(Number(text))) return Number(text);
            return NumConv(DicVal(row, text, 0));
        });

        if (tokens.length === 0) return 0;

        const stack = [NumConv(tokens[0])];
        for (let i = 1; i < tokens.length; i += 2) {
            const operator = String(tokens[i] ?? "");
            const value = NumConv(tokens[i + 1]);
            if (operator === "*") {
                stack[stack.length - 1] = NumConv(stack[stack.length - 1]) * value;
                continue;
            }
            if (operator === "/") {
                stack[stack.length - 1] = value === 0 ? 0 : NumConv(stack[stack.length - 1]) / value;
                continue;
            }
            stack.push(operator, value);
        }

        let result = NumConv(stack[0]);
        for (let i = 1; i < stack.length; i += 2) {
            const operator = String(stack[i] ?? "");
            const value = NumConv(stack[i + 1]);
            result = operator === "-" ? result - value : result + value;
        }

        return result;
    }

    // 明細行配列から合計パネルに表示する1行を計算します。
    function BuildConfiguredTotalRows(panelInfo, detailRows) {
        const definition = ResolveTotalPanelDefinition(panelInfo);
        if (isEmpty(definition) || !Array.isArray(definition.calculations) || definition.calculations.length === 0) return null;

        const rows = Array.isArray(detailRows) ? detailRows : [];
        const totalRow = DefaultTotalRows(panelInfo)[0];

        definition.calculations.forEach(calculation => {
            const targetColumnId = String(DicVal(calculation, "targetColumnId", "")).trim();
            if (targetColumnId === "") return;

            let totalValue = 0;
            rows.forEach(row => {
                if (isEmpty(row)) return;
                totalValue += EvaluateRowFormula(row, DicVal(calculation, "rowFormula", []));
            });
            totalRow[targetColumnId] = totalValue;
        });

        return [totalRow];
    }

    // 計算済みまたはサーバー取得済みの合計行を合計パネルへ反映します。
    function ApplyTotalRows(panelInfo, rows) {
        const totalPanelInfo = ResolveTotalPanelInfo(panelInfo);
        if (isEmpty(totalPanelInfo)) return;

        const sourceRows = Array.isArray(rows) && rows.length !== 0 ? rows : DefaultTotalRows(panelInfo);
        const nextRows = [sourceRows[0] ?? DefaultTotalRows(panelInfo)[0]];
        SetGridData(totalPanelInfo, nextRows);

        const api = GridApi(totalPanelInfo);
        if (!IsAvailableGridApi(api)) return;

        if (typeof api.setGridOption === "function") {
            api.setGridOption('rowData', nextRows);
            return;
        }

        const rowNode = api.getRowNode("TOTAL");
        if (!isEmpty(rowNode) && nextRows.length !== 0) {
            rowNode.setData(nextRows[0]);
        }
    }

    // 明細パネルの内容に合わせて対応する合計パネルを同期します。
    function SyncTotalPanel(panelInfo, detailRows, fallbackRows) {
        if (!HasTotalPanel(panelInfo)) return;

        const calculatedRows = BuildConfiguredTotalRows(panelInfo, detailRows);
        if (Array.isArray(calculatedRows) && calculatedRows.length !== 0) {
            ApplyTotalRows(panelInfo, calculatedRows);
            return;
        }

        if (Array.isArray(fallbackRows) && fallbackRows.length !== 0) {
            ApplyTotalRows(panelInfo, fallbackRows);
            return;
        }

        ApplyTotalRows(panelInfo, DefaultTotalRows(panelInfo));
    }

    // 全明細パネルの合計行を同期します。
    // GetData 後や明細編集後に、素材/附属/副資材の合計欄を更新します。
    function SyncAllTotalPanels(detailData) {
        const serverDetail = isEmpty(detailData) ? {} : detailData;
        const currentPanels = Array.isArray(panelRef.current) ? panelRef.current : [];
        currentPanels.filter(e => e.grid && HasTotalPanel(e)).forEach(panelInfo => {
            const detailRows = GridData({ id: panelInfo.id, type: panelInfo.type });
            const fallbackRows = DicVal(serverDetail, String(DicVal(panelInfo, "totaltype", "")).trim(), null);
            SyncTotalPanel(panelInfo, detailRows, fallbackRows);
        });
    }

    // 現在の列定義から主キー項目を取得します。通常は ZSR_DENNO です。
    function primarykey() {
        if (isEmpty(columninfo)) return "";
        let col = columninfo.find(e => e.primarykey);
        return isEmpty(col) ? "" : col.columnid;
    }

    // EntryInput 側へ再描画トリガーを送ります。
    // entrydataRef を直接更新した後、画面表示へ反映するために使います。
    function TriggerEntryInputRender() {
        dispatch(entryrerender());
    }

    // 派生画面フックへ渡す共通コンテキストを組み立てます。
    // ヘッダー、明細、グリッド操作、通信部品などをフックから参照できるようにします。
    function BuildEntryHookContext(extra = {}) {
        return {
            reason: "",
            config,
            screenId,
            apiController,
            dataController,
            listController,
            formstatus,
            edittingcode,
            entrydataRef,
            textfieldsall,
            textfields,
            originalTextfieldsall: baseFieldSourceRef.current,
            panel: panelRef.current,
            columninfo,
            columns,
            GridData,
            SetGridData,
            ApplyGridData,
            GridApi,
            GridColApi,
            DetailGridList,
            CurrentGridList,
            SyncTotalPanel,
            SyncAllTotalPanels,
            ReplaceBaseFields,
            RefreshGrid,
            RefreshAllDetailGrids,
            TriggerEntryInputRender,
            fnc,
            ...extra
        };
    }

    // 派生画面の applyScreenRules フックを、理由付きで呼び出します。
    function RunEntryHook(reason, extra = {}) {
        if (typeof entryHooks.applyScreenRules !== "function") return;
        entryHooks.applyScreenRules(BuildEntryHookContext({ reason, ...extra }));
    }

    // アンマウント済みでない場合だけ ComFunction の ref を返します。
    function CurrentFnc() {
        if (!mountedRef.current) return null;
        return fnc.current;
    }

    function IsRawPurchaseBrandField(definition) {
        if (isEmpty(definition)) return false;
        return String(DicVal(definition, "columnid", "")).trim().toUpperCase() === RAW_PURCHASE_ENTRY_FIELD_IDS.brandCode
            && String(DicVal(definition, "dataid", "")).trim().toUpperCase() === "M_IBTB";
    }

    function IsRawPurchaseBrandMasterRequest(dataid, param) {
        if (String(isEmpty(dataid) ? "" : dataid).trim().toUpperCase() !== "M_IBTB") return false;
        const refs = Array.isArray(param) ? param : [];
        return refs.some(item =>
            String(DicVal(item, "columnid", "")).trim().toUpperCase() === RAW_PURCHASE_ENTRY_FIELD_IDS.brandCode);
    }

    function NormalizeRawPurchaseBrandCode(value) {
        const text = String(isEmpty(value) ? "" : value).trim();
        if (text.indexOf("_") === -1) return text;
        const parts = text.split("_");
        return parts.length === 0 ? text : parts[parts.length - 1];
    }

    function BuildRawPurchaseBrandRowData(rowdata) {
        const current = isEmpty(rowdata) ? { ...entrydataRef.current } : { ...rowdata };
        const supplierCode = DicVal(current, RAW_PURCHASE_ENTRY_FIELD_IDS.supplierCode,
            DicVal(current, RAW_PURCHASE_ENTRY_FIELD_IDS.supplierCode + "_cd", ""));
        current[RAW_PURCHASE_ENTRY_FIELD_IDS.supplierCode] = supplierCode;
        return current;
    }

    function NormalizeRawPurchaseBrandSearchResult(result) {
        if (isEmpty(result)) return result;
        const item = !isEmpty(result.items) && !isEmpty(result.items[0]) ? result.items[0] : null;
        const itemData = !isEmpty(item) && !isEmpty(item.data) ? item.data : {};
        const brandCode = NormalizeRawPurchaseBrandCode(DicVal(itemData, "IBTB_BRDCD", result.value));
        const brandName = DicVal(itemData, "IBTB_TORIATUKAIBRANDNM",
            DicVal(itemData, "IBTB_BRDRNAME", DicVal(itemData, "name", "")));
        const nextData = {
            ...itemData,
            code: brandCode,
            rowid: brandCode,
            IBTB_BRDCD: brandCode,
            IBTB_TORIATUKAIBRANDNM: brandName
        };

        return {
            ...result,
            value: brandCode,
            items: !isEmpty(item)
                ? [{ ...item, data: nextData }]
                : [{ data: nextData }]
        };
    }

    function ResolveRawPurchaseBrandMasterData(dataid, code, keyinfo, param, rowdata, callback, wait) {
        const currentFnc = CurrentFnc();
        if (isEmpty(currentFnc) || typeof currentFnc.postaxios !== "function") {
            if (typeof callback === "function") callback(null);
            return;
        }

        const brandCode = NormalizeRawPurchaseBrandCode(code);
        if (brandCode === "") {
            if (typeof callback === "function") callback(null);
            return;
        }

        currentFnc.postaxios("RawPurchase/GetBrandMasterData",
            {
                dataid: dataid,
                code: brandCode,
                keyinfo: keyinfo,
                others: param,
                rowdata: BuildRawPurchaseBrandRowData(rowdata)
            },
            {
                onSuccess: function (data) {
                    let returnData = data.returnData;
                    if (!isEmpty(returnData)) {
                        returnData = { ...returnData, dataid: dataid };
                    }
                    if (typeof callback === "function") callback(returnData);
                },
                onError: function () {
                    if (typeof callback === "function") callback(null);
                }
            }, !isEnabled(wait)
        );
    }

    // 待機表示を閉じます。
    function CloseWait() {
        const currentFnc = CurrentFnc();
        if (isEmpty(currentFnc)) return;
        currentFnc.wait(false);
    }

    // 描画後に待機表示を閉じる予約を取り消します。
    function CancelCloseWaitAfterRender() {
        if (closeWaitAfterRenderTimerRef.current === null) return;
        if (typeof window !== "undefined" && typeof window.cancelAnimationFrame === "function") {
            window.cancelAnimationFrame(closeWaitAfterRenderTimerRef.current);
        } else {
            window.clearTimeout(closeWaitAfterRenderTimerRef.current);
        }
        closeWaitAfterRenderTimerRef.current = null;
    }

    // 描画が反映された後に待機表示を閉じます。
    // GetData 後の画面更新が見える前にローディングが消えるのを避けます。
    function CloseWaitAfterRender() {
        CancelCloseWaitAfterRender();
        const finish = () => {
            closeWaitAfterRenderTimerRef.current = null;
            CloseWait();
        };
        if (typeof window !== "undefined" && typeof window.requestAnimationFrame === "function") {
            closeWaitAfterRenderTimerRef.current = window.requestAnimationFrame(() => {
                closeWaitAfterRenderTimerRef.current = window.requestAnimationFrame(finish);
            });
            return;
        }
        closeWaitAfterRenderTimerRef.current = window.setTimeout(finish, 0);
    }

    // 初期値設定が終わった後、ZSR_SANMOTODENKBN 変更による画面遷移を有効にします。
    function EnableSourceCategoryNavigation() {
        window.setTimeout(() => {
            if (!mountedRef.current) return;
            sourceCategoryNavigationReadyRef.current = true;
        }, 0);
    }

    // 参照元伝票区分の候補制限を次のイベントループで適用します。
    // 区分・仕入種別・伝票種別・伝票区分の入力変更直後の state 競合を避けます。
    function ApplySourceCategoryFieldControlAsync() {
        if (sourceCategoryFieldControlTimerRef.current !== null) {
            window.clearTimeout(sourceCategoryFieldControlTimerRef.current);
        }
        sourceCategoryFieldControlTimerRef.current = window.setTimeout(() => {
            sourceCategoryFieldControlTimerRef.current = null;
            if (!mountedRef.current) return;
            ApplySourceCategoryFieldControl();
        }, 0);
    }

    // ZSR_SANMOTODENKBN 変更後の参照元画面切替を非同期に予約します。
    function ScheduleSourceCategoryNavigation(nextSourceCategoryCode) {
        if (sourceCategorySelectionTimerRef.current !== null) {
            window.clearTimeout(sourceCategorySelectionTimerRef.current);
        }
        sourceCategorySelectionTimerRef.current = window.setTimeout(() => {
            sourceCategorySelectionTimerRef.current = null;
            if (!mountedRef.current) return;
            NavigateToSourceCategoryScreen(nextSourceCategoryCode);
        }, 0);
    }

    // クライアント側処理エラーを画面表示し、共通ログ出力 API に記録します。
    // AGENTS.md の「エラーは握りつぶさない」に対応するための処理です。
    function ReportClientProcessingError(processName, error) {
        const normalizedProcessName = String(processName ?? "").trim() === "" ? screenId : String(processName ?? "").trim();
        const errorMessage = error instanceof Error ? error.message : String(error ?? "");
        const displayMessage = "処理中にエラーが発生しました。(" + normalizedProcessName + ")" + (errorMessage === "" ? "" : " " + errorMessage);

        console.error("[" + screenId + "] " + normalizedProcessName, error);
        const currentFnc = CurrentFnc();
        if (isEmpty(currentFnc)) return;
        currentFnc.warnmsg(displayMessage);
        currentFnc.postaxios("common/OutputLog",
            {
                note: screenId + ":" + normalizedProcessName,
                errDescription: errorMessage === "" ? displayMessage : errorMessage
            },
            {
                onSuccess: function () {
                },
                onError: function () {
                }
            },
            true
        );
    }

    // 埋め込み表示または Router state から Entry 起動条件を取得します。
    function ResolveNavigationState() {
        if (embedded && !isEmpty(props.navigationState)) {
            return props.navigationState;
        }
        let state = props.location.state;
        if (isEmpty(state) && !isEmpty(window.history.state) && "status" in window.history.state) {
            state = window.history.state;
        }
        return isEmpty(state) ? {} : state;
    }

    // 遷移 state から編集対象の仕入番号または要求コードを取得します。
    function ResolveNavigationCode(state) {
        if (isEmpty(state)) return "";
        return String(DicVal(state, "code", "") || DicVal(state, "request", "")).trim();
    }

    // 遷移元画面の識別子を取得します。
    // CANCEL や close 時に戻る画面、参照元からの起動元管理に使います。
    function ResolveCallerIdentifier(state) {
        if (isEmpty(state)) return callerIdentifier;
        const keys = ["callerIdentifier"];
        for (let i = 0; i < keys.length; i++) {
            const value = String(DicVal(state, keys[i], "")).trim();
            if (value !== "") return value;
        }
        return callerIdentifier;
    }

    // 遷移元 Controller 名を解決します。
    // List画面や参照元画面へ戻るルートの判断に使います。
    function ResolveCallerController(state) {
        if (!isEmpty(state)) {
            const callerController = String(DicVal(state, "callerController", "")).trim();
            if (callerController !== "") return callerController;
        }
        const requestCallerIdentifier = ResolveCallerIdentifier(state);
        return requestCallerIdentifier === "" ? listController : requestCallerIdentifier;
    }

    // CANCEL 時の遷移先となる controller 名を解決する。
    // CANCEL 時の遷移先となる controller 名を解決します。
    function ResolveCallerRouteController(state) {
        return ResolveCallerController(state);
    }

    // 遷移 state または画面設定から参照元伝票区分を取得します。
    function ResolveSourceCategoryCode(state) {
        if (isEmpty(state)) return sourceCategoryCode;
        const keys = ["sourceCategoryCode"];
        for (let i = 0; i < keys.length; i++) {
            const value = String(DicVal(state, keys[i], "")).trim();
            if (value !== "") return value;
        }
        return sourceCategoryCode;
    }

    // 遷移 state から参照元伝票番号(ZSR_SANSYODENNO)を取得します。
    function ResolveReferenceSlipNo(state) {
        if (isEmpty(state)) return "";
        const keys = ["referenceSlipNo"];
        for (let i = 0; i < keys.length; i++) {
            const value = String(DicVal(state, keys[i], "")).trim();
            if (value !== "") return value;
        }
        return "";
    }

    // 参照元画面から原材料区分を受け取る。
    // 遷移 state から区分(ZSR_ZAIRYOKBN)を取得します。
    // 参照元画面から渡された素材/附属/副資材の区分で表示パネルを切り替えます。
    function ResolveMaterialCategoryCode(state) {
        if (isEmpty(state)) return "";
        if (!Array.isArray(materialCategoryStateKeys) || materialCategoryStateKeys.length === 0) return "";

        for (let i = 0; i < materialCategoryStateKeys.length; i++) {
            const key = String(materialCategoryStateKeys[i] ?? "").trim();
            if (key === "") continue;

            const value = String(DicVal(state, key, "")).trim();
            if (value !== "") return value;
        }

        return "";
    }

    // 遷移 state から仕入種別(ZSR_SIIREKIND)を取得します。
    function ResolvePurchaseKindCode(state) {
        if (isEmpty(state)) return "";
        const keys = ["purchaseKindCode"];
        for (let i = 0; i < keys.length; i++) {
            const value = normalizeRawPurchaseEntryPurchaseKindCode(DicVal(state, keys[i], ""));
            if (value !== "") return value;
        }
        return "";
    }

    // 遷移 state から伝票種別(ZSR_DENSYUBETU)を取得し、判定用コードに正規化します。
    function ResolveSlipTypeCode(state) {
        if (isEmpty(state)) return "";
        const keys = ["slipTypeCode"];
        for (let i = 0; i < keys.length; i++) {
            const value = normalizeRawPurchaseEntrySlipTypeCode(DicVal(state, keys[i], ""));
            if (value !== "") return value;
        }
        return "";
    }

    // 遷移 state から画面入力値として保持する伝票種別を取得します。
    function ResolveSlipTypeInputValue(state) {
        if (isEmpty(state)) return "";
        const keys = ["slipTypeInputValue"];
        for (let i = 0; i < keys.length; i++) {
            const value = String(DicVal(state, keys[i], "")).trim();
            if (value !== "") return value;
        }
        return "";
    }

    // 遷移 state から伝票区分(ZSR_DENKBN)を取得します。
    function ResolveSlipCategoryCode(state) {
        if (isEmpty(state)) return "";
        const keys = ["slipCategoryCode"];
        for (let i = 0; i < keys.length; i++) {
            const value = normalizeRawPurchaseEntrySlipCategoryCode(DicVal(state, keys[i], ""));
            if (value !== "") return value;
        }
        return "";
    }

    // 遷移 state から画面入力値として保持する伝票区分を取得します。
    function ResolveSlipCategoryInputValue(state) {
        if (isEmpty(state)) return "";
        const keys = ["slipCategoryInputValue"];
        for (let i = 0; i < keys.length; i++) {
            const value = String(DicVal(state, keys[i], "")).trim();
            if (value !== "") return value;
        }
        return "";
    }

    // 新規起動時に使う区分コードを解決します。
    function ResolveNewEntryMaterialCategoryCode(state) {
        return ResolveMaterialCategoryCode(state);
    }

    // 参照元画面で選択されていたキー値を API 用の配列に正規化する。
    // 新規または参照起動時に GetData へ渡す追加条件を作ります。
    // 参照元画面、参照元伝票番号、区分、仕入種別、伝票種別、伝票区分を API へ渡します。
    function BuildNewEntryOthers(state) {
        const requestState = isEmpty(state) ? {} : state;
        const requestCallerIdentifier = ResolveCallerIdentifier(requestState);
        const requestCallerController = ResolveCallerController(requestState);
        const requestSourceCategoryCode = ResolveSourceCategoryCode(requestState);
        const referenceSlipNo = ResolveReferenceSlipNo(requestState);
        const materialCategoryCode = ResolveNewEntryMaterialCategoryCode(requestState);
        const purchaseKindCode = ResolvePurchaseKindCode(requestState);
        const slipTypeCode = ResolveSlipTypeCode(requestState);
        const slipTypeInputValue = ResolveSlipTypeInputValue(requestState);
        const slipCategoryCode = ResolveSlipCategoryCode(requestState);
        const slipCategoryInputValue = ResolveSlipCategoryInputValue(requestState);
        const startupMode = referenceSlipNo === "" ? "list-new" : "reference-new";

        let others = {
            startupMode: startupMode,
            callerIdentifier: requestCallerIdentifier,
            callerController: requestCallerController,
            sourceCategoryCode: requestSourceCategoryCode,
            referenceSlipNo: referenceSlipNo,
            controller: dataController,
        };

        if (materialCategoryCode !== "") {
            others.materialCategoryCode = materialCategoryCode;
        }
        if (purchaseKindCode !== "") {
            others.purchaseKindCode = purchaseKindCode;
        }
        if (slipTypeCode !== "") {
            others.slipTypeCode = slipTypeCode;
        }
        if (slipTypeInputValue !== "") {
            others.slipTypeInputValue = slipTypeInputValue;
        }
        if (slipCategoryCode !== "") {
            others.slipCategoryCode = slipCategoryCode;
        }
        if (slipCategoryInputValue !== "") {
            others.slipCategoryInputValue = slipCategoryInputValue;
        }

        return others;
    }

    // 遷移 state で指定された値をヘッダーの entrydata に反映します。
    // 100番台から別参照元へ切り替わったときの入力値引継ぎにも使います。
    function ApplyRequestedEntryValues(targetData, requestState) {
        const nextData = isEmpty(targetData) ? {} : { ...targetData };
        const requestSourceCategoryCode = ResolveSourceCategoryCode(requestState);
        const referenceSlipNo = ResolveReferenceSlipNo(requestState);
        const materialCategoryCode = ResolveNewEntryMaterialCategoryCode(requestState);
        const purchaseKindCode = ResolvePurchaseKindCode(requestState);
        const slipTypeInputValue = ResolveSlipTypeInputValue(requestState);
        const slipCategoryInputValue = ResolveSlipCategoryInputValue(requestState);

        if (requestSourceCategoryCode !== "" || normalizeRawPurchaseEntrySourceCategoryCode(sourceCategoryCode) === "") {
            nextData[sourceCategoryColumnId] = requestSourceCategoryCode;
        }
        if (referenceSlipNo !== "") {
            nextData[RAW_PURCHASE_ENTRY_FIELD_IDS.referenceSlipNo] = referenceSlipNo;
        }
        if (materialCategoryColumnId !== "" && materialCategoryCode !== "") {
            nextData[materialCategoryColumnId] = materialCategoryCode;
        }
        if (purchaseKindCode !== "") {
            nextData[RAW_PURCHASE_ENTRY_COMBINATION_FIELD_IDS.purchaseKindCode] = purchaseKindCode;
        }
        if (slipTypeInputValue !== "") {
            nextData[RAW_PURCHASE_ENTRY_COMBINATION_FIELD_IDS.slipTypeCode] = slipTypeInputValue;
        }
        if (slipCategoryInputValue !== "") {
            nextData[RAW_PURCHASE_ENTRY_COMBINATION_FIELD_IDS.slipCategoryCode] = slipCategoryInputValue;
        }

        return nextData;
    }

    // 指定された区分で隠すべき明細パネル種別を返します。
    function HiddenPanelTypes(materialCategoryCode) {
        const key = String(materialCategoryCode ?? "").trim();
        const panelTypes = hiddenPanelTypesByMaterialCategory[key];
        if (!Array.isArray(panelTypes)) return [];

        const hiddenTypes = [];
        panelTypes.forEach(panelType => {
            const normalized = String(panelType ?? "").trim();
            if (normalized === "") return;
            if (hiddenTypes.indexOf(normalized) !== -1) return;
            hiddenTypes.push(normalized);
        });
        return hiddenTypes;
    }

    // 区分に応じて素材・附属・副資材パネルの表示/非表示を切り替えます。
    function ApplyMaterialCategoryPanelVisibility(targetPanels, materialCategoryCode) {
        if (!Array.isArray(targetPanels) || targetPanels.length === 0) return targetPanels;
        if (materialCategoryControlledPanelTypes.length === 0) return targetPanels;

        const hiddenTypes = HiddenPanelTypes(materialCategoryCode);
        let changed = false;
        const nextPanels = targetPanels.map(panelInfo => {
            if (isEmpty(panelInfo)) return panelInfo;

            const panelType = String(DicVal(panelInfo, "type", "")).trim();
            if (materialCategoryControlledPanelTypes.indexOf(panelType) === -1) return panelInfo;

            const nextHide = hiddenTypes.indexOf(panelType) !== -1;
            if (!!panelInfo.hide === nextHide) return panelInfo;

            changed = true;
            return { ...panelInfo, hide: nextHide };
        });

        return changed ? nextPanels : targetPanels;
    }

    // 現在または指定された区分に合わせてパネル表示を同期します。
    function SyncMaterialCategoryPanels(materialCategoryCode, targetPanels) {
        const sourcePanels = Array.isArray(targetPanels) ? targetPanels : panelRef.current;
        const nextPanels = ApplyMaterialCategoryPanelVisibility(sourcePanels, materialCategoryCode);
        if (nextPanels !== sourcePanels) {
            UpdatePanels(nextPanels);
        }
        return nextPanels;
    }

    // 現在の entrydata から区分(ZSR_ZAIRYOKBN)を取得します。
    function CurrentMaterialCategoryCode() {
        if (materialCategoryColumnId === "") return "";
        return String(DicVal(entrydataRef.current, materialCategoryColumnId, "")).trim();
    }

    // 参照元画面切替時に引き継ぐヘッダー・明細状態を遷移 state から取得します。
    function ResolveCarryoverState(state) {
        if (isEmpty(state)) return null;
        const carryover = DicVal(state, "carryover", null);
        return isEmpty(carryover) ? null : carryover;
    }

    // 引継ぎ方法を解決します。
    // merge は現在入力を残して切替、restore-only は参照元番号検索時の復元専用として扱います。
    function ResolveCarryoverMode(state) {
        if (isEmpty(state)) return "merge";
        const mode = String(DicVal(state, "carryoverMode", "")).trim();
        return mode === "" ? "merge" : mode;
    }

    // 参照元画面を切り替える前に、現在入力中のヘッダーと明細を退避します。
    function CaptureCarryoverState(nextSourceCategoryCode, syncTotals = true) {
        storeRowData(undefined, syncTotals);

        const nextData = DeepCopy(isEmpty(entrydataRef.current) ? {} : entrydataRef.current);
        nextData[sourceCategoryColumnId] = normalizeRawPurchaseEntrySourceCategoryCode(nextSourceCategoryCode);

        const detailByMaterialCategory = {};
        Object.keys(detailPanelTypesByMaterialCategory).forEach(materialCategoryCode => {
            const panelInfo = DetailPanelInfoByMaterialCategory(materialCategoryCode);
            if (isEmpty(panelInfo)) return;

            const rows = GridData(panelInfo);
            if (!Array.isArray(rows)) return;
            detailByMaterialCategory[materialCategoryCode] = DeepCopy(rows);
        });

        return {
            data: nextData,
            detailByMaterialCategory: detailByMaterialCategory
        };
    }

    // 退避したヘッダー値を新しい参照元画面の初期データにマージします。
    // 仕入番号や参照元伝票番号など、切替後に再採番・再入力すべき項目はクリアします。
    function ApplyCarryoverEntryData(targetData, carryover, nextSourceCategoryCode) {
        if (isEmpty(carryover) || isEmpty(carryover.data)) return targetData;

        const mergedData = DeepCopy(isEmpty(targetData) ? {} : targetData);
        Object.keys(carryover.data).forEach(columnId => {
            const carryoverValue = carryover.data[columnId];
            if (isEmpty(carryoverValue) && !isEmpty(mergedData[columnId])) return;
            mergedData[columnId] = carryoverValue;
        });

        carryoverClearColumnIds.forEach(columnId => {
            if (columnId === "") return;
            mergedData[columnId] = "";
        });

        primarykeys.forEach(columnId => {
            if (columnId === "") return;
            mergedData[columnId] = "";
        });

        mergedData[sourceCategoryColumnId] = normalizeRawPurchaseEntrySourceCategoryCode(nextSourceCategoryCode);
        return mergedData;
    }

    // 退避した区分別明細を、切替先画面の対応する明細パネルへ戻します。
    function ApplyCarryoverDetailData(carryover) {
        if (isEmpty(carryover) || isEmpty(carryover.detailByMaterialCategory)) return;

        Object.keys(detailPanelTypesByMaterialCategory).forEach(materialCategoryCode => {
            if (!Object.prototype.hasOwnProperty.call(carryover.detailByMaterialCategory, materialCategoryCode)) return;

            const panelInfo = DetailPanelInfoByMaterialCategory(materialCategoryCode);
            if (isEmpty(panelInfo)) return;

            const rows = DeepCopy(DicVal(carryover.detailByMaterialCategory, materialCategoryCode, []));
            ApplyGridData(panelInfo, rows);
        });
    }

    // 退避状態を entrydataRef・明細・合計・パネル表示にまとめて復元します。
    function RestoreCarryoverState(carryover) {
        if (isEmpty(carryover) || isEmpty(carryover.data)) return;

        entrydataRef.current = NormalizeEntryDataShape(DeepCopy(carryover.data));
        ApplyCarryoverDetailData(carryover);
        SyncMaterialCategoryPanels(CurrentMaterialCategoryCode());
        SyncAllTotalPanels();
        TriggerEntryInputRender();
        rerender();
    }

    // 現在の entrydata から参照元伝票区分(ZSR_SANMOTODENKBN)を取得します。
    function CurrentSourceCategoryCode() {
        return normalizeRawPurchaseEntrySourceCategoryCode(
            DicVal(entrydataRef.current, sourceCategoryColumnId, sourceCategoryCode));
    }

    // 現在の entrydata から仕入種別(ZSR_SIIREKIND)を取得します。
    function CurrentPurchaseKindCode() {
        return normalizeRawPurchaseEntryPurchaseKindCode(
            DicVal(entrydataRef.current, RAW_PURCHASE_ENTRY_COMBINATION_FIELD_IDS.purchaseKindCode, ""));
    }

    // 現在の entrydata から伝票種別(ZSR_DENSYUBETU)を判定用コードで取得します。
    function CurrentSlipTypeCode() {
        return normalizeRawPurchaseEntrySlipTypeCode(
            DicVal(entrydataRef.current, RAW_PURCHASE_ENTRY_COMBINATION_FIELD_IDS.slipTypeCode, ""));
    }

    // 現在の entrydata から伝票種別の画面入力値を取得します。
    function CurrentSlipTypeInputValue() {
        return String(DicVal(entrydataRef.current, RAW_PURCHASE_ENTRY_COMBINATION_FIELD_IDS.slipTypeCode, "") ?? "").trim();
    }

    // 現在の entrydata から伝票区分(ZSR_DENKBN)を判定用コードで取得します。
    function CurrentSlipCategoryCode() {
        return normalizeRawPurchaseEntrySlipCategoryCode(
            DicVal(entrydataRef.current, RAW_PURCHASE_ENTRY_COMBINATION_FIELD_IDS.slipCategoryCode, ""));
    }

    // 現在の entrydata から伝票区分の画面入力値を取得します。
    function CurrentSlipCategoryInputValue() {
        return String(DicVal(entrydataRef.current, RAW_PURCHASE_ENTRY_COMBINATION_FIELD_IDS.slipCategoryCode, "") ?? "").trim();
    }

    // 参照元組み合わせ表を引くための現在の4項目セットを返します。
    function CurrentReferenceCombination() {
        return {
            materialCategoryCode: normalizeRawPurchaseEntryMaterialCategoryCode(CurrentMaterialCategoryCode()),
            purchaseKindCode: CurrentPurchaseKindCode(),
            slipTypeCode: CurrentSlipTypeCode(),
            slipCategoryCode: CurrentSlipCategoryCode()
        };
    }

    // 参照元候補を絞り込むための4項目がすべて入力済みか判定します。
    function IsReferenceCombinationComplete(combination) {
        if (isEmpty(combination)) return false;
        return combination.materialCategoryCode !== ""
            && combination.purchaseKindCode !== ""
            && combination.slipTypeCode !== ""
            && combination.slipCategoryCode !== "";
    }

    // 許可された参照元伝票区分コードだけを、ZSR_SANMOTODENKBN の選択肢形式に変換します。
    function BuildRestrictedSourceCategoryOptions(allowedSourceCategoryCodes) {
        if (!Array.isArray(allowedSourceCategoryCodes) || allowedSourceCategoryCodes.length === 0) {
            return [RAW_PURCHASE_ENTRY_NO_REFERENCE_OPTION];
        }

        const allowedCodes = Array.isArray(allowedSourceCategoryCodes) ? allowedSourceCategoryCodes : [];
        return RAW_PURCHASE_ENTRY_SOURCE_CATEGORY_OPTIONS.filter(option => {
            const optionCode = normalizeRawPurchaseEntrySourceCategoryCode(option.code);
            if (optionCode === "") return false;
            return allowedCodes.indexOf(optionCode) !== -1;
        });
    }

    // 区分・仕入種別・伝票種別・伝票区分に基づいて ZSR_SANMOTODENKBN の選択肢を制限します。
    // 原材料仕入入力参照元組み合わせ表の G列参照元・H列条件・I列備考に対応する入口です。
    function ApplySourceCategoryFieldControl() {
        const currentFields = Array.isArray(textfieldsall) && textfieldsall.length !== 0
            ? textfieldsall
            : baseFieldSourceRef.current;
        const sourceFields = Array.isArray(baseFieldSourceRef.current) && baseFieldSourceRef.current.length !== 0
            ? baseFieldSourceRef.current
            : currentFields;
        if (!Array.isArray(currentFields) || currentFields.length === 0) return false;
        if (!Array.isArray(sourceFields) || sourceFields.length === 0) return false;

        const currentScreenSourceCategoryCode = normalizeRawPurchaseEntrySourceCategoryCode(sourceCategoryCode);
        const currentSourceCategoryCode = CurrentSourceCategoryCode();
        const currentCombination = CurrentReferenceCombination();

        let allowedSourceCategoryCodes = [];
        if (currentScreenSourceCategoryCode === "") {
            if (IsReferenceCombinationComplete(currentCombination)) {
                allowedSourceCategoryCodes = resolveRawPurchaseEntryAllowedSourceCategoryCodes(
                    currentCombination.materialCategoryCode,
                    currentCombination.purchaseKindCode,
                    currentCombination.slipTypeCode,
                    currentCombination.slipCategoryCode);
            }
        } else {
            allowedSourceCategoryCodes = [currentScreenSourceCategoryCode];
        }

        const nextOptions = BuildRestrictedSourceCategoryOptions(allowedSourceCategoryCodes);
        const nextFields = buildUpdatedRawPurchaseEntryFields(currentFields, sourceFields, [sourceCategoryColumnId], field => {
            if (areRawPurchaseEntryFieldOptionsEqual(field.options, nextOptions)) return field;
            return {
                ...field,
                options: nextOptions
            };
        });

        if (nextFields !== null) {
            ReplaceBaseFields(nextFields);
        }

        if (!isEmpty(entrydataRef.current)) {
            if (currentScreenSourceCategoryCode === "") {
                const hasReferenceSource = Array.isArray(allowedSourceCategoryCodes) && allowedSourceCategoryCodes.length > 0;

                if (!hasReferenceSource) {
                    if (entrydataRef.current[sourceCategoryColumnId] !== "") {
                        entrydataRef.current[sourceCategoryColumnId] = "";
                        TriggerEntryInputRender();
                    }
                } else if (currentSourceCategoryCode !== "" && allowedSourceCategoryCodes.indexOf(currentSourceCategoryCode) === -1) {
                    entrydataRef.current[sourceCategoryColumnId] = "";
                    TriggerEntryInputRender();
                }
            } else if (currentSourceCategoryCode !== "" && currentSourceCategoryCode !== currentScreenSourceCategoryCode) {
                entrydataRef.current[sourceCategoryColumnId] = currentScreenSourceCategoryCode;
                TriggerEntryInputRender();
            }
        }

        return false;
    }

    // 参照元伝票番号を入力したとき、参照元データ取得用の遷移 state を作ります。
    function BuildReferenceLookupState(referenceSlipNo) {
        const carryover = CaptureCarryoverState(CurrentSourceCategoryCode(), false);
        if (!isEmpty(carryover) && !isEmpty(carryover.data)) {
            carryover.data[RAW_PURCHASE_ENTRY_FIELD_IDS.referenceSlipNo] = referenceSlipNo;
        }

        return {
            status: "NEW",
            callerIdentifier: activeCallerControllerRef.current,
            callerController: activeCallerControllerRef.current,
            sourceCategoryCode: CurrentSourceCategoryCode(),
            referenceSlipNo: referenceSlipNo,
            materialCategoryCode: CurrentMaterialCategoryCode(),
            purchaseKindCode: CurrentPurchaseKindCode(),
            slipTypeCode: CurrentSlipTypeCode(),
            slipTypeInputValue: CurrentSlipTypeInputValue(),
            slipCategoryCode: CurrentSlipCategoryCode(),
            slipCategoryInputValue: CurrentSlipCategoryInputValue(),
            carryover: carryover,
            carryoverMode: "restore-only"
        };
    }

    // ZSR_SANSYODENNO 入力時に、参照元伝票を読み直して画面へ反映します。
    function LoadReferenceEntry(referenceSlipNo) {
        const normalizedReferenceSlipNo = String(referenceSlipNo ?? "").trim();
        if (normalizedReferenceSlipNo === "") return;
        if (normalizeRawPurchaseEntrySourceCategoryCode(sourceCategoryCode) === "") return;
        LoadNewEntry(BuildReferenceLookupState(normalizedReferenceSlipNo));
    }

    // 新規/参照起動のデータ取得に失敗した場合でも、入力済み条件を画面に戻します。
    function RestoreLoadNewEntryRequestState(requestState, carryover) {
        if (!isEmpty(carryover)) {
            let nextEntryData = ApplyCarryoverEntryData({}, carryover, ResolveSourceCategoryCode(requestState));
            nextEntryData = ApplyRequestedEntryValues(nextEntryData, requestState);
            entrydataRef.current = NormalizeEntryDataShape(nextEntryData);
            RestoreCarryoverState({
                ...carryover,
                data: entrydataRef.current
            });
            return;
        }

        entrydataRef.current = NormalizeEntryDataShape(ApplyRequestedEntryValues({}, requestState));
        SyncMaterialCategoryPanels(CurrentMaterialCategoryCode());
        TriggerEntryInputRender();
        rerender();
    }

    // ZSR_SANMOTODENKBN の選択に応じて、該当する参照元 Entry 画面へ切り替えます。
    // 100番台から300/500/600/700/900番台へ移る処理です。
    function NavigateToSourceCategoryScreen(nextSourceCategoryCode) {
        if (isKnownButUnimplementedRawPurchaseEntrySourceCategoryCode(nextSourceCategoryCode)) {
            if (!isEmpty(entrydataRef.current)) {
                entrydataRef.current[sourceCategoryColumnId] = sourceCategoryCode;
            }
            TriggerEntryInputRender();
            fnc.current.warnmsg("選択した参照元区分の Entry 画面は未実装です");
            return true;
        }

        const currentScreenSourceCategoryCode = normalizeRawPurchaseEntrySourceCategoryCode(sourceCategoryCode);
        if (normalizeRawPurchaseEntrySourceCategoryCode(nextSourceCategoryCode) === currentScreenSourceCategoryCode) return false;
        const referenceSlipNo = currentScreenSourceCategoryCode === ""
            ? String(DicVal(entrydataRef.current, RAW_PURCHASE_ENTRY_FIELD_IDS.referenceSlipNo, "") ?? "").trim()
            : "";
        const carryover = CaptureCarryoverState(nextSourceCategoryCode, false);

        const nextNavigationState = {
            status: "NEW",
            callerIdentifier: activeCallerControllerRef.current,
            callerController: activeCallerControllerRef.current,
            sourceCategoryCode: normalizeRawPurchaseEntrySourceCategoryCode(nextSourceCategoryCode),
            materialCategoryCode: CurrentMaterialCategoryCode(),
            purchaseKindCode: CurrentPurchaseKindCode(),
            slipTypeCode: CurrentSlipTypeCode(),
            slipTypeInputValue: CurrentSlipTypeInputValue(),
            slipCategoryCode: CurrentSlipCategoryCode(),
            slipCategoryInputValue: CurrentSlipCategoryInputValue(),
            referenceSlipNo: referenceSlipNo,
            carryover: carryover,
            carryoverMode: "merge"
        };

        if (embedded && typeof props.onNavigateSourceCategory === "function") {
            props.onNavigateSourceCategory(nextNavigationState);
            return true;
        }
        return false;
    }

    // List画面の検索条件や絞り込み条件を、Entryデータに引き継げる場合だけ補完します。
    function keepListOptionValue(target, source) {
        if (isEmpty(target)) return target;
        if (isEmpty(effectiveListOption) || effectiveListOption.length === 0) return target;

        let newdata = { ...target };
        effectiveListOption.forEach(option => {
            if (isEmpty(option.columnid)) return;
            if (!isEmpty(newdata[option.columnid])) return;
            if (!isEmpty(source) && source[option.columnid] !== undefined) {
                newdata[option.columnid] = source[option.columnid];
            }
        });

        return newdata;
    }

    // 新規起動時に、空の現在値でサーバ側の初期値を潰さないようにマージします。
    function mergeNewEntryDataWithCurrentValues(initialData, currentData) {
        const newdata = isEmpty(initialData) ? {} : { ...initialData };
        if (isEmpty(currentData)) return newdata;

        Object.keys(currentData).forEach(key => {
            if (!isEmpty(currentData[key]) || isEmpty(newdata[key])) {
                newdata[key] = currentData[key];
            }
        });

        return newdata;
    }

    // 項目定義に存在するカラムを entrydata に必ず用意します。
    // MASTER項目の名称列(_nm)も用意し、EntryBase/EntryGridAr の参照エラーを防ぎます。
    function NormalizeEntryDataShape(data, fields) {
        const normalized = isEmpty(data) ? {} : { ...data };
        const sourceFields = Array.isArray(fields) && fields.length !== 0
            ? fields
            : (Array.isArray(textfieldsall) && textfieldsall.length !== 0 ? textfieldsall : baseFieldSourceRef.current);
        if (!Array.isArray(sourceFields)) return normalized;

        sourceFields.forEach(field => {
            if (isEmpty(field) || isEmpty(field.columnid)) return;
            if (!Object.prototype.hasOwnProperty.call(normalized, field.columnid) || normalized[field.columnid] === undefined) {
                normalized[field.columnid] = "";
            }
            if (String(field.datatype ?? "").toUpperCase() === "MASTER") {
                const nameColumnId = field.columnid + "_nm";
                if (!Object.prototype.hasOwnProperty.call(normalized, nameColumnId) || normalized[nameColumnId] === undefined) {
                    normalized[nameColumnId] = "";
                }
            }
        });

        return normalized;
    }

    // コンポーネント破棄時の後始末です。
    // 通信部品の modify 差し替えを戻し、参照元切替用タイマーや描画後待機解除予約を解除します。
    useEffect(() => {
        return () => {
            if (!isEmpty(fnc.current) && originalModifyHandlerRef.current !== null) {
                fnc.current.modify = originalModifyHandlerRef.current;
                originalModifyHandlerRef.current = null;
            }
            if (!isEmpty(fnc.current)
                && originalMasterDataHandlerRef.current !== null
                && fnc.current.getMasterdata === wrappedMasterDataHandlerRef.current) {
                fnc.current.getMasterdata = originalMasterDataHandlerRef.current;
            }
            originalMasterDataHandlerRef.current = null;
            wrappedMasterDataHandlerRef.current = null;
            if (!isEmpty(fnc.current)
                && originalSearchListOpenHandlerRef.current !== null
                && fnc.current.searchlistopen === wrappedSearchListOpenHandlerRef.current) {
                fnc.current.searchlistopen = originalSearchListOpenHandlerRef.current;
            }
            originalSearchListOpenHandlerRef.current = null;
            wrappedSearchListOpenHandlerRef.current = null;
            mountedRef.current = false;
            sourceCategoryNavigationReadyRef.current = false;
            if (sourceCategoryFieldControlTimerRef.current !== null) {
                window.clearTimeout(sourceCategoryFieldControlTimerRef.current);
                sourceCategoryFieldControlTimerRef.current = null;
            }
            if (sourceCategorySelectionTimerRef.current !== null) {
                window.clearTimeout(sourceCategorySelectionTimerRef.current);
                sourceCategorySelectionTimerRef.current = null;
            }
            CancelCloseWaitAfterRender();
        };
    }, []);

    // ComFunction の modify を差し替え、フォームが編集済みかどうかを modifyRef に保持します。
    // CANCEL/NEW 時に「編集内容は破棄されます」の確認を出すための監視です。
    useEffect(() => {
        if (isEmpty(fnc.current) || typeof fnc.current.modify !== "function") return;
        if (originalModifyHandlerRef.current !== null) return;

        originalModifyHandlerRef.current = fnc.current.modify;
        fnc.current.modify = function (flag) {
            modifyRef.current = isEmpty(flag) ? true : flag;
            originalModifyHandlerRef.current(flag);
        };
    });

    useEffect(() => {
        if (isEmpty(fnc.current)) return;
        if (typeof fnc.current.getMasterdata === "function"
            && fnc.current.getMasterdata !== wrappedMasterDataHandlerRef.current) {
            originalMasterDataHandlerRef.current = fnc.current.getMasterdata;
            wrappedMasterDataHandlerRef.current = function (dataid, code, keyinfo, param, rowdata, callback, wait) {
                if (IsRawPurchaseBrandMasterRequest(dataid, param)) {
                    ResolveRawPurchaseBrandMasterData(dataid, code, keyinfo, param, rowdata, callback, wait);
                    return;
                }
                originalMasterDataHandlerRef.current.call(fnc.current, dataid, code, keyinfo, param, rowdata, callback, wait);
            };
            fnc.current.getMasterdata = wrappedMasterDataHandlerRef.current;
        }

        if (typeof fnc.current.searchlistopen === "function"
            && fnc.current.searchlistopen !== wrappedSearchListOpenHandlerRef.current) {
            originalSearchListOpenHandlerRef.current = fnc.current.searchlistopen;
            wrappedSearchListOpenHandlerRef.current = function (param) {
                if (!isEmpty(param) && IsRawPurchaseBrandField(param.data) && typeof param.doApply === "function") {
                    const originalDoApply = param.doApply;
                    const nextParam = {
                        ...param,
                        doApply: function (result) {
                            originalDoApply(NormalizeRawPurchaseBrandSearchResult(result));
                        }
                    };
                    originalSearchListOpenHandlerRef.current.call(fnc.current, nextParam);
                    return;
                }
                originalSearchListOpenHandlerRef.current.call(fnc.current, param);
            };
            fnc.current.searchlistopen = wrappedSearchListOpenHandlerRef.current;
        }
    });

    // GetListTabs の colinfo から取得した COPY FORM クリア対象です。
    // RawPurchaseEntry は同じ columnid が複数 type に存在し、共通処理で重複排除される場合があるため、
    // 現在画面用に絞り込んだ columninfo ではなく、GetListTabs 直後の colinfo から columnid を保持します。
    const copyClearColumnIdsRef = useRef([]);

    // 画面定義(s_logp/s_layout/s_tbl相当)とマスタを読み込み、現在の参照元画面用のパネル・列・グリッドを初期化します。
    // AGENTS.md の「画面骨格は s_layout/s_logp で作る」に対応する初期化処理です。
    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    const currentFnc = CurrentFnc();
                    if (isEmpty(currentFnc)) return;

                    copyClearColumnIdsRef.current = Array.isArray(data.colinfo)
                        ? Array.from(new Set(data.colinfo
                            .filter(e => e.copyclear === true || e.copyclear === 1 || e.copyclear === "1")
                            .map(e => e.columnid)
                            .filter(e => !isEmpty(e))))
                        : [];

                    const currentScreenData = BuildCurrentScreenLayoutData(data);
                    const filteredPanels = currentScreenData.panels;
                    const filteredColInfo = currentScreenData.colinfo;
                    const filteredColumns = currentScreenData.columns;

                    //if (!embedded) {
                    //    dispatch(listtabs(currentScreenData.tabs));
                    //}
                    dispatch(setentrypanel({
                        layouts: currentScreenData.layouts,
                        prelayout: currentScreenData.prelayout,
                        initlayout: Array.isArray(currentScreenData.initlayout) && currentScreenData.initlayout.length === 0 ? " " : currentScreenData.initlayout,
                        fitColumn: currentScreenData.fitColumn
                    }));
                    //if (!embedded) {
                    //    dispatch(listoption(currentScreenData.listoption));
                    //}
                    setcolumninfo(filteredColInfo);
                    setcolumns(filteredColumns);

                    let fields = filteredColInfo
                        .filter(e => e.logpid === G_id.BASE)
                        .map(field => NormalizeBaseFieldDefinition(field));
                    const visibleBaseFields = BuildVisibleBaseFields(fields, filteredColumns);
                    baseFieldSourceRef.current = DeepCopy(fields);
                    entrydataRef.current = NormalizeEntryDataShape(entrydataRef.current, fields);
                    settextfieldsall(fields);
                    settextfields(visibleBaseFields);
                    currentFnc.initMaster(currentScreenData.master);

                    let idx = 0;
                    let glist = [];
                    gridapiRefs.current = [];
                    gridcolapiRefs.current = [];
                    griddataRefs.current = [];
                    gridcolRefs.current = [];
                    filteredPanels.filter(e => e.grid).forEach(function (panelInfo) {
                        gridapiRefs.current[idx] = createRef();
                        gridcolapiRefs.current[idx] = createRef();
                        griddataRefs.current[idx] = createRef();
                        gridcolRefs.current[idx] = createRef();
                        gridcolRefs.current[idx].current = CreatePanelColDef(panelInfo, filteredColInfo, filteredColumns);
                        glist.push({ id: panelInfo.id, type: panelInfo.type, index: idx });
                        idx++;

                        let totalInfo = filteredColInfo.find(e => e.logpid === "T" + panelInfo.id);
                        if (!isEmpty(totalInfo)) {
                            gridapiRefs.current[idx] = createRef();
                            gridcolapiRefs.current[idx] = createRef();
                            griddataRefs.current[idx] = createRef();
                            gridcolRefs.current[idx] = createRef();
                            gridcolRefs.current[idx].current = CreatePanelColDef({ id: "T" + panelInfo.id, type: totalInfo.type }, filteredColInfo, filteredColumns);
                            glist.push({ id: "T" + panelInfo.id, type: totalInfo.type, index: idx });
                            idx++;
                        }
                    });

                    UpdateGridList(glist);
                    UpdatePanels(filteredPanels);

                    if (currentScreenData.prelayout) {
                        RestoreLayout(filteredPanels, fields);
                    }

                    if (isEmpty(locationstate.current)) {
                        locationstate.current = ResolveNavigationState();
                    }
                    let key = search.split("key=")[1];
                    if (isEmpty(locationstate.current) && !isEmpty(key)) {
                        let calldata = Loadstorage(key);
                        locationstate.current = calldata?.state;  //他画面からの連携情報取得
                    }
                    if (ResolveNavigationCode(locationstate.current) === "") {
                        SyncMaterialCategoryPanels(ResolveNewEntryMaterialCategoryCode(locationstate.current), panelRef.current);
                    }
                    if (glist.length === 0) {
                        TryCallShow();
                    }
                }
            });
    }, [search]);

    // ウィンドウサイズ変更を監視し、非埋め込み表示時のパネルナビ幅などを再計算します。
    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // メニュー制御情報から、レイアウト編集ロックとセクション閉じる操作の可否を反映します。
    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1);
    }, [menuinfo]);

    // Redux のフォーム状態を ref に同期します。
    // 非同期処理中でも最新の NEW FORM/ENTRY FORM 判定を参照できるようにします。
    useEffect(() => {
        formstatusRef.current = formstatus;
    }, [formstatus]);

    useEffect(() => {
        NotifyEmbeddedNavmenu();
    });

    // Redux のグリッド一覧を ref に同期します。
    // グリッド準備タイミングの差で古い一覧を参照しないようにします。
    useEffect(() => {
        if (Array.isArray(gridlist) && gridlist.length !== 0) {
            gridListRef.current = gridlist;
        }
    }, [gridlist]);

    // COPY FORM になったとき、s_layout の copyclear 指定列をクリアします。
    // columninfo は現在画面用に絞り込まれており、同一 columnid の他 type 行が落ちることがあるため、
    // GetListTabs 直後に保持した copyClearColumnIdsRef を使用します。
    useEffect(() => {
        if (formstatus !== "COPY FORM" || isEmpty(entrydataRef.current)) return;

        const clearColumnIds = Array.isArray(copyClearColumnIdsRef.current)
            ? copyClearColumnIdsRef.current
            : [];

        let changed = false;

        clearColumnIds.forEach(function (columnid) {
            if (isEmpty(columnid)) return;
            if (entrydataRef.current[columnid] === "") return;

            entrydataRef.current[columnid] = "";
            changed = true;
        });

        if (changed) {
            TriggerEntryInputRender();
        }
    }, [formstatus]);

    // パネル・列・グリッド定義の準備が進むたびに初回表示処理を試みます。
    useEffect(() => {
        TryCallShow();
    }, [gridlist, columninfo, panel, columns]);

    // 埋め込み表示時に、親の RawPurchase.js から新しい参照元遷移要求を受け取ります。
    // List画面内で Entry コンポーネントだけ差し替える構造に対応します。
    useEffect(() => {
        if (!embedded) return;
        if (props.navigationRequestKey === undefined || props.navigationRequestKey === null) return;
        if (isEmpty(props.navigationState)) return;
        if (!initialLoadStartedRef.current) {
            locationstate.current = props.navigationState;
            activeCallerControllerRef.current = ResolveCallerRouteController(props.navigationState);
            return;
        }
        OpenNavigationState(props.navigationState);
    }, [embedded, props.navigationRequestKey]);

    // 初回表示時に、編集データ読込か新規フォーム初期化かを判断して開始します。
    function callshow() {
        if (initialLoadStartedRef.current) return;
        initialLoadStartedRef.current = true;
        sourceCategoryNavigationReadyRef.current = false;

        const state = isEmpty(locationstate.current) ? ResolveNavigationState() : locationstate.current;
        activeCallerControllerRef.current = ResolveCallerRouteController(state);
        const code = ResolveNavigationCode(state);
        locationstate.current = null;

        if (code !== "") {
            setedittingcode(code);
            LoadData(code);
        } else {
            LoadNewEntry(state);
        }
    }

    // 画面初期化はグリッド準備完了後に行う。
    // 列定義とグリッド準備がそろった時点で初回表示処理を呼びます。
    function TryCallShow() {
        if (initialLoadStartedRef.current) return;
        if (BuildRequestColumnInfo().length === 0) return;
        const currentPanels = Array.isArray(panelRef.current) ? panelRef.current : [];
        if (currentPanels.length === 0) return;
        callshow();
    }

    // AG Grid の準備完了時に API を保存し、初回表示を試みます。
    function onGridReady(param, panelInfo) {
        SetGridApi(panelInfo, param.api);
        SetGridColApi(panelInfo, param.columnApi);
        TryCallShow();
    }

    // AG Grid の初回描画後に、初回表示処理の残りを進めます。
    function onFirstDataRendered(param, panelInfo) {
        TryCallShow();
    }

    // 埋め込み表示中に親画面から渡された新しい遷移 state を開きます。
    function OpenNavigationState(state) {
        if (isEmpty(state)) return false;

        locationstate.current = state;
        sourceCategoryNavigationReadyRef.current = false;
        activeCallerControllerRef.current = ResolveCallerRouteController(state);

        if (!initialLoadStartedRef.current) {
            TryCallShow();
            return true;
        }

        const code = ResolveNavigationCode(state);
        if (code !== "") {
            setedittingcode(code);
            LoadData(code);
        } else {
            LoadNewEntry(state);
        }
        return true;
    }

    // MasterBase の entryonly 起動から呼ばれるため、初回読込と NEW FORM の入口をここで受けます。
    // MasterBase から呼ばれる Entry 表示入口です。
    // List画面からの NEW FORM/ENTRY FORM 起動を RawPurchaseEntryBase の初期化処理につなぎます。
    function Show(data, pushcode) {
        if (initialLoadStartedRef.current) {
            if (data === null && isEmpty(pushcode)) {
                const state = ResolveNavigationState();
                activeCallerControllerRef.current = ResolveCallerRouteController(state);
                LoadNewEntry(state);
            }
            return true;
        }

        if (isEmpty(locationstate.current)) {
            locationstate.current = ResolveNavigationState();
        }
        TryCallShow();
        return true;
    }

    // AG Grid 上の現在行を ref に保存し、必要に応じて合計パネルも同期します。
    function storeRowData(panelInfo, syncTotals = true) {
        if (panelInfo === undefined) {
            const grids = DetailGridList();
            for (let i = 0; i < grids.length; i++) {
                const api = GridApi(grids[i]);
                if (!IsAvailableGridApi(api) || isEmpty(AGRef.current)) continue;
                const rows = AGRef.current.GetDatasource(api);
                ApplyDetailContextFieldDefaults(rows);
                SetGridData(grids[i], rows);
            }
            if (syncTotals) {
                SyncAllTotalPanels();
            }
        } else {
            const api = GridApi(panelInfo);
            if (IsAvailableGridApi(api) && !isEmpty(AGRef.current)) {
                const rows = AGRef.current.GetDatasource(api);
                ApplyDetailContextFieldDefaults(rows);
                SetGridData(panelInfo, rows);
            }
            SyncTotalPanel(panelInfo, GridData(panelInfo));
        }
    }

    // 明細セル変更時に行データを保存し、合計再計算と派生フック呼び出しを行います。
    function HandleGridRowValueChanged(panelInfo, colid, rows) {
        const api = GridApi(panelInfo);
        if (IsAvailableGridApi(api) && !isEmpty(AGRef.current)) {
            const gridRows = AGRef.current.GetDatasource(api);
            ApplyDetailContextFieldDefaults(gridRows);
            SetGridData(panelInfo, gridRows);
        }
        SyncTotalPanel(panelInfo, GridData(panelInfo));
        RunEntryHook("grid-row-value-changed", {
            panelInfo: panelInfo,
            changedColumnId: colid,
            changedRows: rows
        });
    }

    // 明細行に不足しているカット代関連の文脈値を、同じ明細内の既存値から補完します。
    function ApplyDetailContextFieldDefaults(rows) {
        if (!Array.isArray(rows) || rows.length === 0) return;

        const defaults = {};
        RAW_PURCHASE_ENTRY_DETAIL_CONTEXT_FIELD_IDS.forEach(fieldId => {
            defaults[fieldId] = "";
        });

        rows.forEach(row => {
            if (isEmpty(row)) return;
            RAW_PURCHASE_ENTRY_DETAIL_CONTEXT_FIELD_IDS.forEach(fieldId => {
                if (!isEmpty(defaults[fieldId])) return;
                if (isEmpty(row[fieldId])) return;
                defaults[fieldId] = row[fieldId];
            });
        });

        if (RAW_PURCHASE_ENTRY_DETAIL_CONTEXT_FIELD_IDS.every(fieldId => isEmpty(defaults[fieldId]))) {
            return;
        }

        rows.forEach(row => {
            if (isEmpty(row)) return;
            RAW_PURCHASE_ENTRY_DETAIL_CONTEXT_FIELD_IDS.forEach(fieldId => {
                if (isEmpty(defaults[fieldId])) return;
                if (!isEmpty(row[fieldId])) return;
                row[fieldId] = defaults[fieldId];
            });
        });
    }

    // 派生フックに明細セル編集可否を問い合わせます。
    function GridLockCell(panelInfo, params, edit, status, panelType) {
        if (typeof entryHooks.gridLockCell !== "function") return edit;
        return entryHooks.gridLockCell(BuildEntryHookContext({
            panelInfo: panelInfo,
            params: params,
            edit: edit,
            status: status,
            panelType: panelType
        }));
    }

    // EntryGridAr の共通フック QuerySetColumn で、この画面専用の編集可否判定を差し込みます。
    // パネル選別やレイアウト復元のために列定義の事前生成は残しつつ、最終的な editable は
    // EntryGridAr 側の正規フックで補正し、参照元明細・カット代行の条件付き編集を共通経路に乗せます。
    function QuerySetGridColumns(panelInfo, colDef) {
        if (!Array.isArray(colDef)) return colDef;
        return colDef.map(column => {
            if (isEmpty(DicVal(column, "colinfo", null))) return column;
            return {
                ...column,
                editable: function (params) {
                    if (DicVal(DicVal(params, "context", {}), "entrylock", false)) return false;
                    return GridLockCell(
                        panelInfo,
                        params,
                        !DicVal(DicVal(column, "colinfo", {}), "locked", false),
                        formstatusRef.current,
                        DicVal(panelInfo, "type", "")
                    );
                }
            };
        });
    }

    // 派生フックに明細行追加の可否を問い合わせます。
    function QueryGridAddRow(panelInfo, rowcount, api) {
        if (typeof entryHooks.queryAddRow !== "function") return true;
        return entryHooks.queryAddRow(BuildEntryHookContext({
            panelInfo: panelInfo,
            rowcount: rowcount,
            api: api
        }));
    }

    // 派生フックに明細行挿入の可否を問い合わせます。
    function QueryGridInsertRow(panelInfo, row) {
        if (typeof entryHooks.queryInsertRow !== "function") return true;
        return entryHooks.queryInsertRow(BuildEntryHookContext({
            panelInfo: panelInfo,
            row: row
        }));
    }

    // 派生フックに明細行削除の可否を問い合わせます。
    function QueryGridRemoveRow(panelInfo, rows) {
        if (typeof entryHooks.queryRemoveRow !== "function") return true;
        return entryHooks.queryRemoveRow(BuildEntryHookContext({
            panelInfo: panelInfo,
            rows: rows
        }));
    }

    // パネルチップやリンク項目から、指定されたヘッダー/明細/備考パネルへスクロールします。
    function Jump(id, type) {
        let panelid = "basepanel" + type;
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        if (id === G_id.NB) panelid = 'remarkspanel' + type;
        if (isEmpty(type)) {
            type = tabletype(id);
        }
        if (panel.some(e => e.id === id && e.type === type && e.grid)) {
            panelid = fnc.current.GridID({ id: id, type: type });
        }
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        EntrybodyRef.current.scrollTop = elem.offsetTop - 50;
    }

    // MasterBase の保存・削除・クリア・閉じる・リンク項目操作を Entry 画面用に処理します。
    function ResolvePrintReportController(action) {
        if (action === "print1") return "GenzairyoSiireReport";
        return "";
    }

    // 対象の原材料仕入伝票を帳票出力します。
    function PrintSlip(action) {
        const reportController = ResolvePrintReportController(action);
        if (reportController === "") return;

        const slipNo = CurrentSlipNo();
        if (slipNo === "") {
            fnc.current.warnmsg("伝票番号が取得できません。");
            return;
        }

        fnc.current.postaxios(reportController + "/Generate", { denNo: slipNo },
            {
                onSuccess: function (data) {
                    const params = {
                        "excelfile": data.returnData["filename"],
                        "dnfile": data.returnData["dnfile"]
                    };
                    fnc.current.filedownload("excel/ExcelDownload", params);
                    fnc.current.wait(false);
                },
                errmsg: "処理に失敗しました"
            }
        );
    }

    // 原材料仕入一括作成画面を開きます。
    function OpenBulkCreate() {
        const state = {
            status: "NEW",
            code: "",
            accepttype: "RawPurchase",
            acceptno: edittingcode
        };
        fnc.current.callform(state, "RawSupplyInbulk");
    }

    // 現在の入力状態から更新用の送信データを組み立てます。
    function BuildWarningSignature(warning) {
        if (isEmpty(warning)) return "";
        const table = String(DicVal(warning, "table", ""));
        const isDetailWarning = table.toUpperCase() === "D_ZSRM";
        return [
            table,
            String(DicVal(warning, "type", "")),
            isDetailWarning ? "" : String(DicVal(warning, "rowid", "")),
            isDetailWarning ? "" : String(DicVal(warning, "col", "")),
            String(DicVal(warning, "message", DicVal(warning, "Message", "")))
        ].join("|");
    }

    function BuildConfirmedWarningRequest(confirmedWarnings) {
        if (!Array.isArray(confirmedWarnings) || confirmedWarnings.length === 0) return "";
        return "confirmedWarnings:" + confirmedWarnings
            .filter(signature => !isEmpty(signature))
            .map(signature => encodeURIComponent(signature))
            .join("\n");
    }

    function BuildEntrySaveParam(entryData, nocheck, confirmedWarnings) {
        var detail = {};
        const grids = DetailGridList();
        for (let i = 0; i < grids.length; i++) {
            detail[grids[i].type] = GridData({ id: grids[i].id, type: grids[i].type });
        }

        const saveData = { ...entryData };
        saveData.ZSR_LOADED_AT = DicVal(entrydataRef.current, "ZSR_LOADED_AT", "");

        return {
            "controller": dataController,
            "data": saveData,
            "detail": detail,
            "images": imageRef.current,
            "colinfo": columninfo,
            "code": edittingcode,
            "noconfirm": nocheck,
            "request": BuildConfirmedWarningRequest(confirmedWarnings)
        };
    }

    function BuildCurrentSaveParam(nocheck) {
        storeRowData();
        return BuildEntrySaveParam(entrydataRef.current, nocheck);
    }

    // 申請解除による承認状態の更新を、専用 API で保存します。
    function ExecuteWithdrawUpdate(nocheck) {
        storeRowData();

        const paramdata = BuildEntrySaveParam(entrydataRef.current, nocheck);

        fnc.current.postaxios(apiController + "/AppCancel", paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        const code = data.request;
                        setedittingcode(code);
                        dispatch(changestatus("ENTRY FORM"));
                        fnc.current.success();
                        LoadData(code);
                    }
                    else {
                        if (isEnabled(data.confirm)) {
                            var msgs = ["警告を確認して申請解除する場合は OK、修正する場合は Cancel を押してください。", " "];
                            for (let i = 0; i < data.warning.length; i++) {
                                msgs.push("・" + data.warning[i].message);
                            }
                            fnc.current.confmsg(msgs, () => ExecuteWithdrawUpdate(true));
                        } else {
                            let msg = data.warning.length + "件のチェックエラーにより申請解除できませんでした。";
                            fnc.current.showwarndescription(msg, data.warning);
                        }
                    }
                    fnc.current.wait(false);
                },
                errmsg: "申請解除に失敗しました"
            }
        );
    }

    // 申請解除可否をフロントエンド上で確認し、通過した場合のみ承認状態を更新します。
    function WithdrawApplication() {
        const reqFlg = String(DicVal(entrydataRef.current, "ZSR_REQFLG", "")).trim();
        /*
        if (reqFlg === "") {
            fnc.current.warnmsg("申請解除判定用の申請フラグが取得できていません。画面取得設定を確認してください。");
            return;
        }
        if (reqFlg === "0") {
            fnc.current.warnmsg("このデータは申請されていません");
            return;
        }

        const synFlg1 = String(DicVal(entrydataRef.current, "ZSR_SYNFLG1", "")).trim();
        if (synFlg1 === "") {
            fnc.current.warnmsg("申請解除判定用の承認状態が取得できていません。画面取得設定を確認してください。");
            return;
        }
        if (synFlg1 === "2") {
            fnc.current.warnmsg("承認済のデータは変更不可です。");
            return;
        }
        if (synFlg1 === "3") {
            fnc.current.warnmsg("却下のデータは変更不可です。");
            return;
        }
        if (synFlg1 !== "0" && synFlg1 !== "1") {
            fnc.current.warnmsg("申請解除できる承認状態ではありません。");
            return;
        }

        const slipNo = CurrentSlipNo();
        if (slipNo === "") {
            fnc.current.warnmsg("伝票番号が取得できません。");
            return;
        }

        const invoiceExists = String(DicVal(entrydataRef.current, "ZSR_CANCELAPP_IVD_EXISTS", "")).trim();
        if (invoiceExists === "") {
            fnc.current.warnmsg("申請解除判定用の Invoice 情報が取得できていません。画面取得設定を確認してください。");
            return;
        }
        if (invoiceExists !== "1") {
            fnc.current.warnmsg("Invoiceが登録されていません。");
            return;
        }

        const supplyExists = String(DicVal(entrydataRef.current, "ZSR_CANCELAPP_ZSK_EXISTS", "")).trim();
        if (supplyExists === "") {
            fnc.current.warnmsg("申請解除判定用の支給伝票情報が取得できていません。画面取得設定を確認してください。");
            return;
        }
        if (supplyExists === "1") {
            fnc.current.warnmsg("本伝票を参照している有効な支給伝票が存在する為、申請解除はできません。");
            return;
        }
        */
        fnc.current.confmsg("申請解除します。宜しいでしょうか？", () => {
            ExecuteWithdrawUpdate(false);
        });
    }

    function MenuAction(action, finallycallback) {
        LayoutSaveStorage();

        if (action === 'save') {
            Save(finallycallback);
            return;
        }
        if (action === 'delete') {
            Delete(finallycallback);
            return;
        }
        if (action === "clear") {
            LoadNewEntry(ResolveNavigationState());
            return;
        }
        if (action === "close") {
            if (embedded) return;
            history.push("/" + activeCallerControllerRef.current);
            return;
        }
        if (action === "bulkcreate") {
            OpenBulkCreate();
            return;
        }
        if (action === "withdraw") {
            WithdrawApplication();
            return;
        }
        if (action === "print1") {
            PrintSlip(action);
            return;
        }
        if (action !== 'linkfield') return;

        let col = textfields.find(e => e.columnid === finallycallback.field && (isEmpty(finallycallback.type) ? true : e.type === finallycallback.type));
        if (col === undefined) return;
        if (col.logpid === "0") {
            let key = finallycallback.field + "_" + col.type;
            document.getElementById(key).focus();
            document.getElementById(key).select();
            Jump(G_id.BASE, col.type);
            return;
        }
        let logpid = col.logpid;
        Jump(logpid, col.type);
        AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, GridApi({ id: logpid, type: col.type }));
    }

    // MasterBase の削除確認メッセージより前に、承認済および有効な支給伝票参照による削除不可を確認します。
    function QueryAction(action) {
        if (action !== "delete") return true;

        const approvalStatus = String(DicVal(entrydataRef.current, "ZSR_SYNFLG1", "")).trim();
        if (approvalStatus === "2") {
            fnc.current.warnmsg("承認済のデータは変更不可です。");
            return false;
        }

        const supplyExists = String(DicVal(entrydataRef.current, "ZSR_CANCELAPP_ZSK_EXISTS", "")).trim();
        if (supplyExists === "1") {
            fnc.current.warnmsg("本伝票を参照している有効な支給伝票が存在する為、削除できません。");
            return false;
        }

        return true;
    }

    // 親コンポーネントから保存・削除などのメニュー操作や遷移 state 開封を呼べるように公開します。
    // RawPurchase.js が埋め込み Entry に対して操作を中継するための窓口です。
    useImperativeHandle(ref, () => ({
        MenuAction: MenuAction,
        QueryAction: QueryAction,
        BuildSaveParam: BuildCurrentSaveParam,
        Save: Save,
        OpenNavigationState: OpenNavigationState
    }));

    // Entry 専用のステータスボタン操作です。
    // Entry 専用の CANCEL/COPY/NEW 操作を処理します。
    function EntryStatusAction(action) {
        if (action === "cancel") {
            if (modifyRef.current) {
                fnc.current.confmsg("編集内容は破棄されます。よろしいですか?", () => history.push("/" + activeCallerControllerRef.current));
                return;
            }
            history.push("/" + activeCallerControllerRef.current);
            return;
        }

        if (action === "copy") {
            dispatch(changestatus("COPY FORM"));
            return;
        }

        if (action === "new") {
            const executeNew = () => LoadNewEntry(ResolveNavigationState());
            if (modifyRef.current) {
                fnc.current.confmsg("編集内容は破棄されます。よろしいですか?", executeNew);
                return;
            }
            executeNew();
        }
    }

    // 共通の StatusNav に渡す Entry 用のステータス選択肢です。
    // 現在のフォーム状態に応じて StatusNav に表示する Entry 操作を返します。
    function EntryStatusOptions(status) {
        if (status === "ENTRY FORM") {
            return ["CANCEL", "COPY", "NEW"];
        }
        if (status === "NEW FORM" || status === "COPY FORM") {
            return ["CANCEL"];
        }
        return [];
    }

    // 共通の StatusNav から選択された操作だけをこの画面で処理します。
    // StatusNav から来た操作名を EntryStatusAction に渡します。
    function HandleEntryStatusAction(action) {
        EntryStatusAction(String(action).toLowerCase());
    }

    // ヘッダー・明細・画像をまとめて InsertEntry/UpdateEntry に送信します。
    // D_ZSR と D_ZSRM を保存し、警告確認が必要な場合は確認後に再実行します。
    function Save(finallycallback, nocheck, confirmedWarnings) {
        storeRowData();
        const paramdata = BuildEntrySaveParam(entrydataRef.current, nocheck, confirmedWarnings);
        fnc.current.postaxios(formstatus === "ENTRY FORM" ? apiController + "/UpdateEntry" : apiController + "/InsertEntry", paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        const code = data.request;
                        const pkey = primarykey();
                        if (formstatus !== "ENTRY FORM" && pkey !== "") {
                            entrydataRef.current[pkey] = data.request;
                        }
                        setedittingcode(code);
                        dispatch(changestatus("ENTRY FORM"));
                        fnc.current.success();
                        if (typeof finallycallback === "function" && formstatus === "ENTRY FORM" && !isEmpty(data.data)) {
                            finallycallback(data.data);
                        }
                        LoadData(code);
                    }
                    else {
                        if (isEnabled(data.confirm)) {
                            const warning = data.warning[0];
                            const warningMessage = DicVal(warning, "message", DicVal(warning, "Message", ""));
                            var msgs = ["警告を確認して登録する場合は OK、修正する場合は Cancel を押してください。", " "];
                            msgs.push("・" + warningMessage);
                            const nextConfirmedWarnings = Array.isArray(confirmedWarnings) ? [...confirmedWarnings] : [];
                            nextConfirmedWarnings.push(BuildWarningSignature(warning));
                            fnc.current.confmsg(msgs, () => Save(finallycallback, true, nextConfirmedWarnings));
                        } else {
                            let msg = data.warning.length + "件のチェックエラーにより登録できませんでした。";
                            fnc.current.showwarndescription(msg, data.warning);
                        }
                    }
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました"
            }
        );
    }

    // 現在の仕入伝票を削除 API に送信します。
    function Delete(finallycallback) {
        const param = {
            rowdata: [{ "rowid": edittingcode }],
            controller: dataController
        };
        fnc.current.postaxios(apiController + "/Delete", param,
            {
                onSuccess: function (data) {
                    const currentFnc = fnc.current;
                    if (data.warning.length === 0) {
                        if (!isEmpty(currentFnc)) {
                            currentFnc.success();
                            currentFnc.wait(false);
                        }
                        if (typeof finallycallback === "function") {
                            finallycallback(edittingcode, primarykeys);
                        }
                        if (!embedded) {
                            history.push("/" + listController);
                        }
                    }
                    else {
                        if (!isEmpty(currentFnc)) {
                            currentFnc.warnmsg(["このデータは削除できません", data.warning[0].message]);
                            currentFnc.wait(false);
                        }
                    }
                },
                errmsg: "削除に失敗しました"
            }
        );
    }

    // 既存の仕入番号を GetData で読み込み、ヘッダー・明細・画像・合計・参照元制御を画面へ反映します。
    function LoadData(code) {
        if (code === "") return;
        const requestColumnInfo = BuildRequestColumnInfo();

        fnc.current.postaxios(apiController + '/GetData', { "code": code, "colinfo": requestColumnInfo, "columns": columns, "controller": dataController, "panels": panelRef.current },
            {
                onSuccess: function (data) {
                    try {
                        fnc.current.margeMaster(data.master);
                        entrydataRef.current = keepListOptionValue(data.data, entrydataRef.current);
                        SyncMaterialCategoryPanels(CurrentMaterialCategoryCode());

                        const grids = DetailGridList();
                        for (let i = 0; i < grids.length; i++) {
                            const detailRows = DicVal(data.detail, grids[i].type, null);
                            if (Array.isArray(detailRows) ? detailRows.length !== 0 : !isEmpty(detailRows)) {
                                ApplyGridData({ id: grids[i].id, type: grids[i].type }, detailRows);
                            }
                        }
                        SyncAllTotalPanels(data.detail);
                        RunEntryHook("after-load-data", { response: data });
                        ApplySourceCategoryFieldControl();

                        imageRef.current = isEmpty(data.images) ? [] : data.images;
                        dispatch(setimagelist(imageRef.current));
                        const responseCallerController = String(DicVal(data.returnData, "callerController", "")).trim();
                        if (responseCallerController !== "") {
                            activeCallerControllerRef.current = responseCallerController;
                        }
                        const responseCaller = String(DicVal(data.returnData, "callerIdentifier", "")).trim();
                        if (responseCallerController === "" && responseCaller !== "") {
                            activeCallerControllerRef.current = ResolveCallerRouteController({ callerIdentifier: responseCaller });
                        }
                        TriggerEntryInputRender();
                        rerender();
                        dispatch(changestatus("ENTRY FORM"));
                        EnableSourceCategoryNavigation();
                    } catch (error) {
                        ReportClientProcessingError("LoadData", error);
                    } finally {
                        CloseWaitAfterRender();
                    }
                },
                onError: function (data) {
                    let msg = "データ取得に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    const currentFnc = CurrentFnc();
                    if (!isEmpty(currentFnc)) {
                        currentFnc.warnmsg(msg);
                    }
                    CloseWait();
                }
            }
        );
    }

    // 新規起動時は API から初期値を受け取り、参照起動で既存伝票が見つかった場合はその内容を同じ応答で受け取る。
    // NEW FORM または参照起動時の初期データを GetData で取得します。
    // 参照元番号から既存伝票が解決された場合は ENTRY FORM として表示します。
    function LoadNewEntry(state) {
        const requestState = isEmpty(state) ? {} : state;
        const others = BuildNewEntryOthers(requestState);
        const carryover = ResolveCarryoverState(requestState);
        const carryoverMode = ResolveCarryoverMode(requestState);
        setedittingcode("");
        if (formstatusRef.current !== "NEW FORM") {
            formstatusRef.current = "NEW FORM";
            dispatch(changestatus("NEW FORM"));
        }

        clearform(true, () => {
            fnc.current.postaxios(apiController + '/GetData',
                { "code": "", "colinfo": BuildRequestColumnInfo(), "columns": columns, "controller": dataController, "panels": panelRef.current, "others": others },
                {
                    onSuccess: function (data) {
                        try {
                            if (data.status === false) {
                                const msg = isEmpty(data.errDescription) ? "データ取得に失敗しました" : data.errDescription;
                                RestoreLoadNewEntryRequestState(requestState, carryover);
                                dispatch(changestatus("NEW FORM"));
                                EnableSourceCategoryNavigation();
                                const currentFnc = CurrentFnc();
                                if (!isEmpty(currentFnc)) {
                                    currentFnc.warnmsg(msg);
                                }
                                return;
                            }

                            const resolvedEntryCode = String(DicVal(data.returnData, "resolvedEntryCode", "")).trim();
                            const startupMode = String(DicVal(data.returnData, "startupMode", "")).trim();
                            const nextSourceCategoryCode = ResolveSourceCategoryCode(requestState);
                            const isExistingReferenceEntry = startupMode === "reference-existing" && resolvedEntryCode !== "";
                            const isReferenceLookupLoad = carryoverMode === "restore-only";

                            fnc.current.margeMaster(data.master);
                            const currentEntryData = isEmpty(entrydataRef.current) ? {} : entrydataRef.current;
                            let nextEntryData = keepListOptionValue(isExistingReferenceEntry || isReferenceLookupLoad ? {
                                ...currentEntryData,
                                ...(isEmpty(data.data) ? {} : data.data)
                            } : mergeNewEntryDataWithCurrentValues(data.data, currentEntryData), currentEntryData);
                            if (!isExistingReferenceEntry && carryoverMode !== "restore-only") {
                                nextEntryData = ApplyCarryoverEntryData(nextEntryData, carryover, nextSourceCategoryCode);
                            }
                            if (!isExistingReferenceEntry && !isReferenceLookupLoad) {
                                nextEntryData = ApplyRequestedEntryValues(nextEntryData, requestState);
                            }
                            entrydataRef.current = NormalizeEntryDataShape(nextEntryData);
                            SyncMaterialCategoryPanels(CurrentMaterialCategoryCode());

                            const grids = DetailGridList();
                            for (let i = 0; i < grids.length; i++) {
                                const detailRows = DicVal(data.detail, grids[i].type, null);
                                if (Array.isArray(detailRows) ? detailRows.length !== 0 : !isEmpty(detailRows)) {
                                    ApplyGridData({ id: grids[i].id, type: grids[i].type }, detailRows);
                                }
                            }
                            if (!isExistingReferenceEntry && carryoverMode !== "restore-only") {
                                ApplyCarryoverDetailData(carryover);
                            }
                            SyncAllTotalPanels(data.detail);
                            RunEntryHook("after-load-new-entry", { response: data, requestState: requestState });
                            ApplySourceCategoryFieldControl();
                            imageRef.current = isEmpty(data.images) ? [] : data.images;
                            dispatch(setimagelist(imageRef.current));
                            const responseCallerController = String(DicVal(data.returnData, "callerController", "")).trim();
                            if (responseCallerController !== "") {
                                activeCallerControllerRef.current = responseCallerController;
                            }
                            const responseCaller = String(DicVal(data.returnData, "callerIdentifier", "")).trim();
                            if (responseCallerController === "" && responseCaller !== "") {
                                activeCallerControllerRef.current = ResolveCallerRouteController({ callerIdentifier: responseCaller });
                            }
                            if (resolvedEntryCode !== "") {
                                setedittingcode(resolvedEntryCode);
                            }
                            TriggerEntryInputRender();
                            rerender();
                            const nextStatus = startupMode === "reference-existing" ? "ENTRY FORM" : "NEW FORM";
                            if (formstatusRef.current !== nextStatus) {
                                formstatusRef.current = nextStatus;
                                dispatch(changestatus(nextStatus));
                            }
                            EnableSourceCategoryNavigation();
                        } catch (error) {
                            ReportClientProcessingError("LoadNewEntry", error);
                        } finally {
                            CloseWaitAfterRender();
                        }
                    },
                    onError: function (data) {
                        RestoreLoadNewEntryRequestState(requestState, carryover);
                        if (!isEmpty(data) && !isEmpty(data.errDescription)) {
                            const currentFnc = CurrentFnc();
                            if (!isEmpty(currentFnc)) {
                                currentFnc.warnmsg(data.errDescription);
                            }
                        }
                        dispatch(changestatus("NEW FORM"));
                        EnableSourceCategoryNavigation();
                        CloseWait();
                    }
                }
            );
        });
    }

    // 新規入力用にヘッダー、明細、画像を初期化し、SQL初期値も取得します。
    function clearform(newform, callback) {
        entrydataRef.current = NormalizeEntryDataShape(initializedata(textfieldsall, staff));
        imageRef.current = [];

        const currentGridList = CurrentGridList();
        for (let i = 0; i < currentGridList.length; i++) {
            SetGridData(currentGridList[i], null);
        }
        SyncAllTotalPanels();

        dispatch(setimagelist([]));
        fnc.current.modify(false);

        if (isEnabled(newform)) {
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
                {
                    onSuccess: function (data) {
                        try {
                            const currentEntryData = isEmpty(entrydataRef.current) ? {} : entrydataRef.current;
                            for (let key in data.returnData) {
                                var col = textfieldsall.find(e => e.columnid === key);
                                if (!isEmpty(col)) col.initvalue = data.returnData[key];
                            }
                            entrydataRef.current = NormalizeEntryDataShape({
                                ...initializedata(textfieldsall, staff),
                                ...currentEntryData
                            });
                            if (typeof callback !== "function") {
                                TriggerEntryInputRender();
                                rerender();
                            }
                            if (typeof callback === "function") callback();
                        } catch (error) {
                            ReportClientProcessingError("clearform-GetInitSqlValue", error);
                        }
                    },
                    onError: function () {
                        if (typeof callback === "function") callback();
                    }
                }, true
            );
            return;
        }

        rerender();
        if (typeof callback === "function") callback();
    }

    // ヘッダー項目変更時の共通入口です。
    // ZSR_SANMOTODENKBN の画面遷移、区分によるパネル切替、参照元番号読込、参照元候補制限を処理します。
    function ValueChanged(id, value, edit) {
        if (id === sourceCategoryColumnId) {
            if (!sourceCategoryNavigationReadyRef.current) return;
            if (edit !== true) return;
            ScheduleSourceCategoryNavigation(value);
            return;
        }
	        if (id === materialCategoryColumnId) {
	            SyncMaterialCategoryPanels(CurrentMaterialCategoryCode());
	        }
	        RunEntryHook("base-value-changed", {
	            changedColumnId: id,
	            changedValue: value,
	            edit: edit
	        });
	        // 派生画面フックはヘッダー変更を契機に明細行の単価・金額を補正することがあります。
	        // 合計欄への反映は全画面共通の責務のため、フック実行後に必ず共通側で再同期します。
	        SyncAllTotalPanels();
	        const referenceSlipNoChanged = id === RAW_PURCHASE_ENTRY_FIELD_IDS.referenceSlipNo;
	        const sourceCategoryFieldChanged = id === materialCategoryColumnId
	            || id === RAW_PURCHASE_ENTRY_COMBINATION_FIELD_IDS.purchaseKindCode
	            || id === RAW_PURCHASE_ENTRY_COMBINATION_FIELD_IDS.slipTypeCode
            || id === RAW_PURCHASE_ENTRY_COMBINATION_FIELD_IDS.slipCategoryCode;
        if (sourceCategoryFieldChanged) {
            ApplySourceCategoryFieldControlAsync();
        }
        if (referenceSlipNoChanged && edit === true) {
            LoadReferenceEntry(value);
            return;
        }
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col) && col.extriggerref) {
            dispatch(entrytriggercall(id));
        }
    }

    // 基本情報パネルのレイアウト設定画面を開きます。
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }

    // 保存済みパネル配置と基本情報項目配置を復元します。
    function RestoreLayout(panels, fields) {
        RestorePanel(panels);
        RestoreBase(fields);
    }

    // ユーザー別に保存されたパネル表示順・開閉状態を復元します。
    function RestorePanel(panelData) {
        let saved = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(saved)) return;
        if (panelData.length !== saved.length) return;
        for (let i = 0; i < saved.length; i++) {
            let item = panelData.find(e => e.id === saved[i].id && e.type === saved[i].type);
            if (isEmpty(item)) return;
            saved[i] = {
                ...item,
                ...saved[i],
                name: item.name,
                name2: item.name2,
                abbr: item.abbr
            };
        }
        UpdatePanels(saved);
    }

    // ユーザー別に保存された基本情報項目の表示順を復元します。
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }

    // 現在の明細列状態、基本情報項目、パネル状態をローカル保存します。
    function LayoutSaveStorage() {
        const currentGridList = CurrentGridList();
        for (let i = 0; i < currentGridList.length; i++) {
            AGRef.current.SaveColState(
                fnc.current.statusKey(currentGridList[i].id, currentGridList[i].type, formid),
                EmptyPanel(currentGridList[i].id, currentGridList[i].type) ? null : GridColApi({ id: currentGridList[i].id, type: currentGridList[i].type })
            );
        }
        Savestorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid), textfields);
        Savestorage(corpkey, account, formid + "panel", panel);
    }

    // 現在の画面レイアウトを共通レイアウトとしてサーバーへ保存します。
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            if (panel[p].id === G_id.BASE) {
                if (setbase) break;
                let fds = textfields.filter(x => !x.hide);
                for (let f = 0; f < fds.length; f++) {
                    coldef.push({
                        headerName: fds[f].columnnm,
                        table: fds[f].table,
                        field: fds[f].columnid,
                        width: fds[f].width,
                        type: fds[f].type
                    });
                }
                setbase = true;
            } else {
                cols = AGRef.current.GetshownColDef(GridColApi({ id: panel[p].id, type: panel[p].type }));
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id, panel[p].type);
                coldef.push(col);
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function () {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        );
    }

    // 選択された保存済み Entry レイアウトを削除します。
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        );
    }

    // 保存済み Entry レイアウトを読み込み、現在の参照元画面に該当する列・パネルだけを反映します。
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    const filteredPanels = FilterCurrentScreenPanels(data.panels);
                    const filteredColumns = FilterCurrentScreenColumns(data.columns);
                    const currentGridList = CurrentGridList();
                    for (let i = 0; i < currentGridList.length; i++) {
                        var coldef = CreatePanelColDef(currentGridList[i], columninfo, filteredColumns);
                        if (coldef.length === 0) continue;
                        SetGridColDef({ id: currentGridList[i].id, type: currentGridList[i].type }, coldef);
                    }
                    UpdatePanels(filteredPanels);
                    SyncMaterialCategoryPanels(CurrentMaterialCategoryCode());
                    settextfields(BuildVisibleBaseFields(
                        Array.isArray(textfieldsall) && textfieldsall.length !== 0
                            ? textfieldsall
                            : baseFieldSourceRef.current,
                        filteredColumns));
                    setcolumns(filteredColumns);
                    fnc.current.wait(false);
                },
            }
        );
    }

    // 指定パネルの表示/非表示を切り替えます。
    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        UpdatePanels(newpanel);
    }

    // 基本情報パネルで表示する項目を、レイアウト設定画面の選択結果に差し替えます。
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e => e.type !== type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
    }

    // パネルIDから対応する s_lo_type を解決します。
    function tabletype(id, type) {
        if (!isEmpty(type)) return type;
        if (id.substr(0, 1) === "T") {
            if (isEmpty(columninfo)) return "";
            let col = columninfo.find(e => e.logpid === id);
            if (isEmpty(col)) return '';
            return col.type;
        } else {
            let pnl = panelRef.current.find(e => e.id === id);
            if (isEmpty(pnl)) return '';
            return pnl.type;
        }
    }

    // ツールバー上でパネルチップを並べ替えた結果を panel state に反映します。
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        UpdatePanels(arrayMove(panel, oldidx, newidx));
    };

    // 非埋め込み表示時のパネルナビゲーション幅を計算します。
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }

    // パネルジャンプ用の並べ替え可能なチップを描画します。
    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.name}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));

    // 表示中パネルだけをチップ化し、ドラッグ並べ替えできる一覧として描画します。
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} />
                ))}
            </ul>
        );
    });

    // パネル種別に応じて、基本情報・画像・明細グリッド・合計グリッド・備考を描画します。
    function Contents(contentProps) {
        if (contentProps.panel.id === G_id.BASE) {
            const baseid = "basepanel" + contentProps.panel.type;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={contentProps.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (contentProps.panel.id === G_id.IMAGE) {
            return (
                <EntryImages
                    fnc={fnc}
                    controller={dataController}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                />
            );
        }
        if (contentProps.panel.grid) {
            const gridIndex = GridIndex(contentProps.panel);
            if (gridIndex === -1) return null;
            if (isEmpty(griddataRefs.current[gridIndex])) return null;
            if (isEmpty(gridcolRefs.current[gridIndex])) return null;
            const totalPanelInfo = ResolveTotalPanelInfo(contentProps.panel);
            let totalIndex = -1;
            if (!isEmpty(totalPanelInfo)) {
                totalIndex = GridIndex(totalPanelInfo);
            }
            return (
                <React.Fragment>
                    <EntryGridAr
                        id={fnc.current.GridID(contentProps.panel)}
                        entrydataRef={entrydataRef}
                        dataRef={griddataRefs.current[gridIndex]}
                        columnRef={gridcolRefs.current[gridIndex]}
                        columninfo={columninfo}
                        columns={columns}
                        fnc={fnc}
                        onGridReady={onGridReady}
                        onFirstDataRendered={onFirstDataRendered}
                        ValueChanged={() => storeRowData(contentProps.panel)}
                        RemoveRow={() => storeRowData(contentProps.panel)}
                        RowValueChanged={(colid, rows) => HandleGridRowValueChanged(contentProps.panel, colid, rows)}
                        lockcell={(params, edit, status, panelType) => GridLockCell(contentProps.panel, params, edit, status, panelType)}
                        QuerySetColumn={(colDef) => QuerySetGridColumns(contentProps.panel, colDef)}
                        QueryAddRow={(rowcount, api) => QueryGridAddRow(contentProps.panel, rowcount, api)}
                        QueryInsertRow={(row) => QueryGridInsertRow(contentProps.panel, row)}
                        QueryRemoveRow={(rows) => QueryGridRemoveRow(contentProps.panel, rows)}
                        AutoAddRow={!ShouldDisableDetailAutoAddRow(contentProps.panel)}
                        formid={formid}
                        panel={contentProps.panel}
                    />
                    {isEmpty(totalPanelInfo) || totalIndex === -1 || isEmpty(griddataRefs.current[totalIndex]) || isEmpty(gridcolRefs.current[totalIndex]) ? null :
                        <EntryGridAr
                            id={fnc.current.GridID("T" + contentProps.panel.id)}
                            entrydataRef={entrydataRef}
                            dataRef={griddataRefs.current[totalIndex]}
                            columnRef={gridcolRefs.current[totalIndex]}
                            columninfo={columninfo}
                            columns={columns}
                            fnc={fnc}
                            onGridReady={onGridReady}
                            onFirstDataRendered={onFirstDataRendered}
                            formid={formid}
                            panel={contentProps.panel}
                            total={true}
                        />
                    }
                </React.Fragment>
            );
        }
        if (contentProps.panel.id === G_id.NB) {
            if (isEmpty(columninfo)) return null;
            let coldef = columninfo.find(e => e.type === contentProps.panel.type);
            return (
                <EntryRemarks
                    id={"remarkspanel" + contentProps.panel.type}
                    def={coldef}
                    dataRef={entrydataRef}
                    fnc={fnc}
                    ValueChanged={ValueChanged}
                />
            );
        }
        return null;
    }

    // 表示対象の列や項目がない空パネルかどうかを判定します。
    function EmptyPanel(id, type) {
        try {
            const currentPanels = Array.isArray(panelRef.current) && panelRef.current.length !== 0 ? panelRef.current : panel;
            if (!currentPanels.some(e => e.id === id)) return true;
            if (!isEmpty(type)) {
                if (!currentPanels.some(e => e.id === id && e.type === type)) return true;
            }
            if (id === G_id.BASE) return isEmpty(textfields.find(e => e.type === type));
            let tbltype = tabletype(id, type);
            return !columns.some(e => e.type === tbltype);
        } catch { }
        return false;
    }

    // パネルを画面に表示しない条件を判定します。
    // 空パネル、画像なしの画像パネル、ユーザーが閉じたパネルを非表示にします。
    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (p.id === G_id.IMAGE) {
            if (isEmpty(imageRef.current)) return true;
            if (imageRef.current.length === 0) return true;
            return p.hide;
        }
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }

    // 現在表示可能なパネルを縦に並べて Entry 画面本体を描画します。
    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', paddingBottom: embedded ? '5px' : '300px', boxSizing: 'border-box', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef}>
                {panel.filter(p => !panelhidden(p)).map((p, i) => {
                    return (
                        <Box
                            key={p.id + "_" + p.type + "_" + i}
                            display="flex"
                            justifyContent="space-around"
                            alignItems="center"
                            padding="5px"
                        >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                            >
                                <div style={{ position: 'relative', marginBottom: 5 }}>
                                    {p.name} - <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                    {p.id !== '0' || layoutlock ? null :
                                        <div style={{ position: 'absolute', right: 40, top: -3 }} title="レイアウト設定">
                                            <IconButton size="small" onClick={() => SetBaseField(p.type)}  >
                                                <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                    {layoutlock || sectionclose ? null :
                                        <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                            <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                                <Icon style={{ fontSize: 16 }}>close</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                </div>
                                <Contents panel={p} />
                            </Paper >
                        </Box>
                    );
                })}
            </div>
        );
    }

    // Entry 画面上部のパネルジャンプ・並べ替え・レイアウト設定ボタンを描画します。
    function EntryToolbar() {
        if (!(formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM')) return null;

        if (embedded) {
            return (
                <div style={{
                    position: 'absolute',
                    top: -36,
                    left: 210,
                    right: 15,
                    zIndex: 2,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8
                }}>
                    <Paper
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            listStyle: 'none',
                            p: 0.5,
                            m: 0,
                        }}
                        component="ul"
                        elevation={0}
                        style={{ backgroundColor: "transparent", flex: 1, minWidth: 0, overflowX: 'auto' }}
                    >
                        <SortablePanelSelector
                            axis={"x"}
                            items={panel}
                            onSortEnd={onPanelSortEnd}
                            distance={2}
                        />
                    </Paper>
                    <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                        <Icon>table_chart</Icon>
                    </IconButton>
                </div>
            );
        }

        return (
            <div>
                <div style={{ position: 'absolute', top: 60, right: 15 }}>
                    <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                        <Icon>table_chart</Icon>
                    </IconButton>
                </div>
                <div style={{ position: 'absolute', top: 60, left: 210 }}>
                    <Paper
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            listStyle: 'none',
                            p: 0.5,
                            m: 0,
                        }}
                        component="ul"
                        elevation={0}
                        style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                    >
                        <SortablePanelSelector
                            axis={"x"}
                            items={panel}
                            onSortEnd={onPanelSortEnd}
                            distance={2}
                        />
                    </Paper>
                </div>
            </div>
        );
    }

    return (
        <div style={embedded ? { height: '100%', minHeight: 0, overflow: 'hidden' } : undefined}>
            <RawPurchaseEntryBaseComFunc ref={fnc} />
            <RawPurchaseEntryBaseAGFunc ref={AGRef} />
            <EntryToolbar />
            {embedded ?
                <EntryForm />
                :
                <MasterBase
                    formid={formid}
                    controller={controller}
                    subkey={subkey}
                    location={props.location}
                    actionurl={{}}
                    tabs={false}
                    navmenu={navmenu}
                    entrydataRef={entrydataRef}
                    entrycallback={MenuAction}
                    entryform={true}
                    entryonly={true}
                    entrystatusoptions={EntryStatusOptions}
                    entrystatusaction={HandleEntryStatusAction}
                    suppressaction={suppressaction}
                    show={Show}
                >
                    <EntryForm />
                </MasterBase>}
            <EntryLayout
                columninfo={textfieldsall}
                textfields={textfields}
                onAppry={SetLayout}
            />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
        </div>
    );
});
